<template>
  <div class="d-flex flex-column flex-column-fluid no-gutters">
    <div class="subheader py-2 py-lg-6 subheader-solid" id="kt_subheader">
      <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
        <div class="d-flex align-items-center flex-wrap mr-1">
          <div class="d-flex align-items-baseline flex-wrap mr-5">
            <h3 class="text-dark font-weight-bold my-1 mr-5">
              {{$t('customers')}} 
            </h3>
            <ul class="breadcrumb breadcrumb-transparent breadcrumb fs-6 font-weight-bold p-0 my-2 font-size-sm">
              <li class="breadcrumb-item pe-3">
                <router-link aria-haspopup="true" to="/dashboard/customers" exact >{{$t('customers_list')}}</router-link>
              </li>
              <li class="breadcrumb-item px-3 text-muted">{{$t('customer')}} {{$t('details')}}</li>
            </ul>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <router-link
            to="/dashboard/customers/"
            class="btn btn-primary _4margin-r-10"
            role="button"
            >{{$t('back_to')}} {{$t('customers_list')}}</router-link
          >
        </div>
      </div>
    </div>
    <div class="d-flex flex-column-fluid">
      <div class="container">
        <div class="row">
          <div class="col-6 col-md-12 col-xl-3 h-115px">
            <!--begin::Stats Widget 31-->
            <div class="card card-custom  card-shadowless gutter-b">
              <!--begin::Body-->
              <div class="text-center bg-success text-white font-size-h6 rounded-top-left rounded-top-right">{{$t('spend')}}</div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 text-center mt-2">
                      <i class="far fa-money-bill-alt moneyIconColor fa-2x" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <span class="card-title font-weight-bold font-size-h6 mb-0 mt-2 d-block">{{brand_currency_symbol}}{{commaSeprator(totalSpend)}}</span>
                    </div>
                  </div>
                </div>
              <!--end::Body-->
            </div>
            <!--end::Stats Widget 31-->
          </div>
          <div class="col-6 col-md-12 col-xl-3 h-115px">
            <!--begin::Stats Widget 31-->
            <div class="card card-custom card-shadowless gutter-b">
              <!--begin::Body-->
              <div class="text-center bg-warning text-white font-size-h6 rounded-top-left rounded-top-right">{{$t('orders')}}</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 text-center mt-2">
                    <i class="fa fa-shopping-cart shoppingIconColor fa-2x" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <span class="card-title font-weight-bold font-size-h6 mb-0 mt-2 d-block">{{commaSeprator(totalOrders)}}</span>
                  </div>
                </div>
              </div>
              <!--end::Body-->
            </div>
            <!--end::Stats Widget 31-->
          </div>
          <div class="col-6 col-md-12 col-xl-3 h-115px">
            <!--begin::Stats Widget 31-->
            <div class="card card-custom  card-shadowless gutter-b">
              <!--begin::Body-->
              <div class="text-center bg-primary text-white font-size-h6 rounded-top-left rounded-top-right">{{$t('last_order')}}</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 text-center mt-2">
                    <i class="fa fa-calendar calendarIconColor fa-2x" aria-hidden="true"></i>

                  </div>
              </div>
              <div class="row">
                  <div class="col-md-12 text-center">
                    <span class="card-title font-weight-bold font-size-h6 mb-0 mt-2 d-block">{{lastOrderDate}}</span>
                  </div>
              </div>
              </div>
              <!--end::Body-->
            </div>
            <!--end::Stats Widget 31-->
          </div>
          <div class="col-6 col-md-12 col-xl-3 h-115px">
            <!--begin::Stats Widget 31-->
            <div class="card card-custom  card-shadowless gutter-b">
              <!--begin::Body-->
              <div class="text-center bg-success text-white font-size-h6 rounded-top-left rounded-top-right">{{ $t('outstanding_invoices') }}</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 text-center mt-2">
                    <i class="far fa-file-alt fileIconColor fa-2x" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <span class="card-title font-weight-bold font-size-h6 mb-0 mt-2 d-block">{{commaSeprator(outstandingInvoices)}}</span>
                  </div>
                </div>
              </div>
              <!--end::Body-->
            </div>
            <!--end::Stats Widget 31-->
          </div>
          <div class="col-6 col-md-12 col-xl-3 h-115px">
            <!--begin::Stats Widget 31-->
            <div class="card card-custom card-shadowless gutter-b">
              <!--begin::Body-->
              <div class="text-center bg-danger text-white font-size-h6 rounded-top-left rounded-top-right">{{$t('outstanding')}} {{$t('balance')}}</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 text-center mt-2">
                      <i class="far fa-credit-card fa-2x creditIconColor" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <span class="card-title font-weight-bold font-size-h6 mb-0 mt-2 d-block">{{brand_currency_symbol}}{{commaSeprator(outstandingBalance)}}</span>
                  </div>
                </div>
              </div>
              <!--end::Body-->
            </div>
            <!--end::Stats Widget 31-->
          </div>
          <div class="row mb-4">
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-custom gutter-b">
              <div class="card-header card-header-tabs-line">
                <div class="card-toolbar customer-detail-tabs-toolbar">
                  <ul class="nav nav-tabs nav-bold nav-tabs-line customer-detail-tabs">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        data-toggle="tab"
                        href="#kt_tab_pane_1_9"
                      >
                        <span class="nav-text text-weight-bold"
                          >{{$t('company')}} {{$t('details')}}</span
                        >
                      </a>
                    </li>
                    <li class="nav-item" v-if="status==='active'">
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_2_9">
                        <span class="nav-text">{{$t('customer')}} {{$t('Contacts')}}</span>
                      </a>
                    </li>
                    <li class="nav-item dropdown d-md-none" v-if="status==='active'">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="customer_detail_more_tabs"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="nav-text">{{ $t('more') }}</span>
                      </a>
                      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="customer_detail_more_tabs">
                        <button type="button" class="dropdown-item" @click="selectTab('kt_tab_pane_3_9')">{{$t('addresses')}}</button>
                        <button type="button" class="dropdown-item" @click="selectTab('kt_tab_pane_4_9')">
                          {{$t('notes')}}
                          <span v-if="totalNotes?.length > 0" class="label label-rounded label-danger">{{ totalNotes }}</span>
                        </button>
                        <button type="button" class="dropdown-item" @click="selectTab('kt_tab_pane_5_9')">{{$t('documents')}}</button>
                        <button type="button" class="dropdown-item" @click="selectTab('kt_tab_pane_6_9')">{{$t('orders')}}</button>
                        <button type="button" class="dropdown-item" @click="selectTab('kt_tab_pane_7_9')">{{ $t('order_products') }}</button>
                        <button
                          v-if="isPayflowConnected || isAuthorizeConnected || isPaylianceConnected || isStripeConnected || isSquareConnected"
                          type="button"
                          class="dropdown-item"
                          @click="selectTab('kt_tab_pane_8_9')"
                        >
                          {{$t('payment_info')}}
                        </button>
                        <button type="button" class="dropdown-item" @click="selectTab('kt_tab_pane_9_9')">
                          {{$t('notification')}} {{$t('emails')}}
                        </button>
                      </div>
                    </li>
                    <li class="nav-item d-none d-md-block" v-if="status==='active'">
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_3_9">
                        <span class="nav-text">{{$t('addresses')}}</span>
                      </a>
                    </li>
                    <li class="nav-item d-none d-md-block" v-if="status==='active'">
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_4_9">
                        <span class="nav-text">
                          {{$t('notes')}} &nbsp;
                          <span v-if="totalNotes?.length > 0"
                            class="label label-rounded label-danger"
                            >{{ totalNotes }}
                          </span>
                        </span>
                      </a>
                    </li>
                    <li class="nav-item d-none d-md-block" v-if="status=='active'">
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_5_9">
                        <span class="nav-text">{{$t('documents')}}</span>
                      </a>
                    </li>
                    <li class="nav-item d-none d-md-block" v-if="status=='active'">
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_6_9">
                        <span class="nav-text">{{$t('orders')}}</span>
                      </a>
                    </li>
                    <li class="nav-item d-none d-md-block" v-if="status=='active'">
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_7_9">
                        <span class="nav-text">{{ $t('order_products') }}</span>
                      </a>
                    </li>
                    <li class="nav-item d-none d-md-block" v-if="(isPayflowConnected || isAuthorizeConnected ||isPaylianceConnected || isStripeConnected || isSquareConnected) && status=='active'" >
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_8_9">
                        <span class="nav-text">{{$t('payment_info')}}</span>
                      </a>
                    </li>
                    <li class="nav-item d-none d-md-block" v-if="status==='active'">
                      <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_9_9">
                        <span class="nav-text">{{$t('notification')}} {{$t('emails')}}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="container-fluid d-flex align-items-center justify-content-end flex-wrap flex-sm-nowrap mb-4">
                      <div class="d-flex align-items-right pt-4 pr-0" >
                        <div v-if="$store.getters.permissions.includes('update_customer')">
                          <router-link
                            v-if="deleted_at == null && status==='active'"
                            class="btn btn-sm btn-light-primary font-weight-bolder ml-1 mr-2"
                            aria-haspopup="true"
                            :to="{
                              name: 'brand-edit-customer',
                              params: { id: customerId },
                            }"
                            exact
                            ><i
                              class="fas fa-edit"
                            ></i
                            >{{$t('edit')}} {{$t('customer')}}
                          </router-link>
                        </div>
                        <div class="cartbutton" v-if="status == 'active' && totalCartProducts != 0">
                          <a
                            href="#"
                            class="btn btn-sm btn-primary _4margin-r-10 router-link-active ml-1 mr-2 orderlistButton"
                            data-toggle="modal"
                            data-target="#products_in_cart_modal"
                          >
                            <i class="fas fa-shopping-cart"></i>
                            {{$t('products_in_cart')}}&nbsp;<span>{{commaSeprator(totalCartProducts)}}</span>
                          </a>
                        </div>
                        <div v-if="combineOrdersData.length > 0">
                          <button
                            type="button"
                            class="btn btn-sm btn-light-primary font-weight-bolder mr-1"
                            @click="combineInvoices()">
                            <i class="far fa-file-alt"></i>{{ $t('view') }} {{$t('invoice')}}
                          </button>
                        </div>
                        <button
                          type="button"
                          id="dropdownMenuButton"
                          class="btn btn-sm btn-light-primary font-weight-bolder dropdown-toggle ml-1 mr-2"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          v-show="status != 'deleted'"
                          v-if="$store.getters.permissions.includes('delete_customer') || $store.getters.permissions.includes('update_customer')"
                        >
                          <i class="fas fa-download"></i> {{$t('actions')}}
                        </button>
                        <template v-if="deleted_at != null">
                          <a
                            href="#"
                            class="btn btn-sm btn-primary mr-2 orderlistButton"
                            @click="patchRestoreBrandCustomer()"
                          >
                            <i class="fa fa-undo" aria-hidden="true"></i>
                            <span>{{ $t('restore_customer') }}</span>
                          </a>
                        </template>
                        <div class="dropdown-menu" v-if="$store.getters.permissions.includes('delete_customer') || $store.getters.permissions.includes('update_customer')">
                          <ul class="navi navi-hover">
                            <li class="navi-item">

                            </li>
                            <li class="navi-item" v-if="company_name == 'Test Company' ">
                            </li>
                            <li class="navi-item" v-if="$store.getters.permissions.includes('delete_customer') && company_name !== 'Test Company' ">
                              <a
                                href="javascript:;"
                                @click.prevent="deleteCustomer(id)"
                                class="navi-link"
                              >
                                <i
                                  class="flaticon-delete text-dark mr-3 text-black-50"
                                ></i>
                                <span>{{$t('delete')}}</span>
                              </a>
                            </li>
                            <li class="navi-item cursor-pointer" v-if="status == 'active' && $store.getters.permissions.includes('update_customer')">
                              <a
                              class="navi-link"
                              v-on:click="disableCustomer()"
                              >
                                <i class="fa fa-lock text-dark mr-3 text-black-50" aria-hidden="true"></i>
                                <span>{{$t('Inactive')}}</span>
                              </a>
                            </li>
                            <li class="navi-item cursor-pointer" v-else>
                              <a
                              v-if="$store.getters.permissions.includes('update_customer')"
                              class="navi-link"
                              v-on:click="enableCustomer()"
                              >
                                <i class="fa fa-unlock text-dark mr-3 text-black-50"></i>
                                <span>{{$t('active')}}</span>
                              </a>
                            </li>
                            <li class="navi-item" v-if="$store.getters.permissions.includes('update_customer')">
                              <a
                              v-if="deleted_at == null && status=='active'"
                              href="#"
                              class="navi-link"
                              v-on:click="resendWelcomeEmail()"
                              >
                                <i class="fa fa-paper-plane text-dark mr-3 text-black-50"></i>
                                <span>{{$t('resend_welcome_email')}}</span>
                              </a>
                            </li>
                            <li class="navi-item" v-if="$store.getters.permissions.includes('update_customer')">
                              <a
                              v-if="deleted_at == null && status=='active'"
                              href="#"
                              class="navi-link"
                              data-toggle="modal"
                              data-target="#store_credit_modal"
                              >
                                <i class="fa fa-pencil-alt text-dark mr-3 text-black-50"></i>
                                <span>{{$t('edit')}} {{$t('store_credit')}}</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
              <div class="card-body">
                <div class="tab-content">
                  <div class="tab-pane fade show active"
                    id="kt_tab_pane_1_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_1_9"
                  >
                  <div class="accordion customer-detail-info">
                      <div class="container">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card mb-8 rounded">
                              <div class="card-header">
                                  <div class="card-title collapsed">
                                      <b> {{$t('company')}} {{$t('information')}} </b>
                                  </div>
                              </div>
                              <div>
                                  <div class="card-body py-10">
                                    <div class="form-group row">
                                      <div class="col-md-6">
                                        <label>{{$t('company')}} {{$t('name')}}:</label><br>
                                        <span>{{ company_name }}</span>
                                      </div>
                                      <div class="col-md-6">
                                        <label class="">{{$t('phone_number')}}:</label><br>
                                        <span>{{ phone_number }}</span>
                                      </div>
                                      <div class="col-md-6 pt-3" v-if="quickbooks_status == 'connected'">
                                        <label class="">{{$t('quickbooks')}} {{$t('customer')}}:</label><br>
                                        <span v-if="quickbooks_status == 'connected'">{{ quickbooks_customer_name }}</span>
                                          <span v-else>{{$t('not_linked')}}</span>
                                      </div>
                                      <div class="col-md-6 pt-3" v-if="cin7_status == 'connected'">
                                        <label class="">Cin7 {{$t('customer')}}:</label><br>
                                        <span>{{ cin7_customer_name }}</span>
                                      </div>
                                      <template v-if="xero_status == 'connected'">
                                        <div class="col-md-6 pt-3">
                                        <label class="">{{$t('xero')}} {{$t('customer')}}:</label><br>
                                        <span v-if="xero_status == 'connected'">{{ xero_customer_name }}</span>
                                          <span v-else>{{$t('not_linked')}}</span>
                                        </div>
                                      </template>
                                      <div class="col-md-6 pt-3" v-if="hubspot_status == 'connected'">
                                        <label class="">HubSpot {{$t('customer')}}:</label><br>
                                        <span>{{ hubspot_customer_name }}</span>
                                      </div>
                                      <div class="col-md-6 pt-3" >
                                        <label class="">{{$t('customer')}} {{$t('status')}}:</label><br>
                                        <span v-if="status" :class="status === 'active' ? 'label label-lg label-success label-inline mr-2 text-capitalize' : 'label label-lg label-danger label-inline text-capitalize'">{{ $t(status) }}</span>
                                      </div>
                                      <div class="col-md-6 pt-3" v-if="customerTags.length>0">
                                        <label class="">{{$t('customer')}} {{$t('tags')}}:</label><br>
                                        <span v-for="(customer_tag, index) in customerTags" :key="index" class="label label-lg label-success label-inline mr-2 text-capitalize">{{ customer_tag }}</span>
                                      </div>
                                      <div class="col-md-6 pt-3">
                                        <label>{{$t('primary')}} {{$t('customer')}} {{$t('contact')}} {{$t('login')}}:</label><br>
                                        <span v-if="loginEnabled == 1 ">{{ $t('yes') }}</span>
                                        <span v-else>{{ $t('no') }}</span>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-md-6">
                            <div class="card mb-8">
                              <div class="card-header">
                                <div class="card-title collapsed">
                                  <b>Primary Customer Contact</b>
                                </div>
                              </div>
                              <div>
                                <div class="card-body py-10">
                                  <div class="form-group row">
                                    <div class="col-md-3">
                                      <label>Enable Login:</label><br>
                                      <span v-if="loginEnabled == 1 ">Yes</span>
                                      <span v-else>No</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <div class="container">
                        <div class="row">
                          <div class="col-md-6 d-flex">
                            <div class="card mb-8 rounded flex-grow-1">
                                <div class="card-header">
                                    <div class="card-title collapsed">
                                        <b>{{$t('order')}} {{$t('settings')}}</b>
                                    </div>
                                </div>
                                <div>
                                    <div class="card-body py-10">
                                      <div class="form-group row">
                                        <div class="col-md-6">
                                          <label class="">{{$t('price_tier')}}:</label><br>
                                          <span class="text-dark ">{{brand_price_tier}}</span>
                                          <!-- <span
                                            class="text-dark"
                                            v-for="(option, index) in price_tiers_options"
                                            :key="index"
                                            v-if="option.id == brand_price_tier"
                                            >
                                              <span v-if="option.name == 'msrp'">{{ option.display_name}}</span>
                                              <span v-else>{{ option.name}}</span>
                                            </span> -->
                                        </div>
                                        <div class="col-md-6">
                                          <label>{{$t('minimum_order')}}:</label><br>
                                          <span class="text-dark ">{{brand_currency_symbol}}{{ minimum_order }}</span>
                                        </div>
                                        <div class="col-md-6 pt-3">
                                          <label class="">{{$t('customer')}} {{$t('currency')}}:</label><br>
                                          <span>{{ brandCurrency }}</span>
                                        </div>
                                        <div class="col-md-6 pt-3" v-if="warehousesCount > 1">
                                          <label class="">{{$t('Warehouse')}} {{$t('Location')}}:</label><br>
                                          <span>{{ warehouse }}</span>
                                        </div>
                                        <div class="col-md-6 pt-3" v-if="brand_promo_code">
                                          <label class="">{{$t('promo_code')}}:</label><br>
                                          <span class="text-dark ">{{
                                            brand_promo_code
                                          }}</span>
                                        </div>
                                        <div class="col-md-6 pt-3" v-if="$store.getters.brand['enable_customer_credit_limit'] == 1">
                                          <label class="">{{$t('credit_limit')}}:</label><br>
                                          <span>{{brand_currency_symbol}}{{ commaSeprator(credit_limit)}}</span>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                          <div class="col-md-6 d-flex">
                            <div class="card mb-8 rounded flex-grow-1">
                                <div class="card-header">
                                    <div class="card-title collapsed">
                                        <b>{{$t('tax_info_sales_rep')}}</b>
                                    </div>
                                </div>
                                <div>
                                <div class="card-body py-10">
                                    <div class="form-group row">
                                      <div class="col-md-6" v-if="tax_id">
                                        <label>{{$t('tax_id')}}:</label><br>
                                        <span>{{ tax_id }}</span>
                                      </div>
                                      <div v-if="!isLicenseBrand" class="col-md-6">
                                        <label>{{ $store.state.brand.subdomain === 'nativemaps' ? 'CC Processing Fee' : $t('tax_rate_override') }}:</label><br>
                                        <span>{{ commaSeprator(tax_rate)}}%</span>
                                      </div>
                                      <div class="col-md-6 form-group ">
                                        <label>{{$t('default_payment_terms')}}:</label><br>
                                        <span>{{ days_invoices_due }} {{ $t('days') }}</span>
                                      </div>
                                      <div class="col-md-6 form-group">
                                        <label class="">{{$t('representative')}}:</label><br>
                                        <span>{{ rep_name }}</span>
                                      </div>
                                      <div class="col-md-6"  v-if="this.$store.state.brand_settings['show_custom_customer_field'] == '1' && customFieldText">
                                        <label>{{customFieldText}}:</label><br>
                                        <span>{{customFieldValue}}</span>
                                      </div>
                                    </div> 
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  </div>
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_2_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_2_9"
                  >
                   <div class="container">
                    <div class="custom-card">
                      <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap tabContentHeader py-3 pr-0">
                        <div class="d-flex align-items-center flex-wrap ml-1">
                          <div class="d-flex align-items-baseline flex-wrap">
                            <span class="text-dark">
                              {{$t('you_may')}} <span class="text-danger">{{$t('edit_delete')}}</span> {{$t('customer')}} {{$t('Contacts')}} {{$t('from_here')}}
                            </span>
                          </div>
                        </div>
                        <div class="d-flex align-items-center" v-if="$store.getters.permissions.includes('create_customer')">
                          <button type="button" class="btn btn-sm btn-success mr-9" data-toggle="modal" data-target="#contact-person-modal" v-on:click="triggerAddContactPerson()">
                            {{$t('add_customer')}} {{$t('Contacts')}}
                          </button>
                        </div>
                      </div>
                      <div class="card-body pl-6 table-responsive">
                        <!-- <div class="card-toolbar float-right mb-5">
                          <button
                            type="button"
                            class="btn btn-sm btn-success"
                            data-toggle="modal"
                            data-target="#contact-person-modal"
                            v-on:click="triggerAddContactPerson()"
                          >
                            <i class="fa fa-plus"></i>Add Customer Contact
                          </button>
                        </div>
                        <div class="pt-2">
                          <span class="font-size-lg font-weight-bolder py-5">
                            You may <code>edit/delete</code> Customers Contact from
                            here.
                          </span>
                        </div> -->
                        <!--begin::Section-->
                        <table
                          id="customer-contacts-table"
                          class="table text-center table-sm table-head-bg-brand table-bordered"
                        >
                          <thead class="thead-inverse">
                            <tr>
                              <th class="w-15px">#{{$t('hash_tag')}}</th>
                              <th>{{$t('type')}}</th>
                              <th>{{$t('name')}}</th>
                              <th>{{$t('email')}}</th>
                              <th>{{$t('username')}}</th>
                              <th>{{$t('phone_number')}}</th>
                              <th>{{$t('enable')}} {{$t('login')}}</th>
                              <th v-if="$store.getters.permissions.includes('update_customer') || $store.getters.permissions.includes('delete_customer')">{{$t('action')}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(row, rindex) in contactPersons"
                              :key="rindex"
                            >
                              <td>{{ rindex + 1 }}</td>
                              <td class="text-capitalize">{{ row.contact_type }}</td>
                              <td>{{ row.name }}</td>
                              <td>{{ row.email }}</td>
                              <td>{{ row.username }}</td>
                              <td>{{ row.phone_number }}</td>
                              <td v-if="row.login_enabled">
                                  {{$t('yes')}}
                              </td>
                              <td v-else>
                                  {{$t('no')}}
                              </td>
                              <td v-if="$store.getters.permissions.includes('update_customer') || $store.getters.permissions.includes('delete_customer') ">
                                <div class="dropdown">
                                  <a
                                    href="javascript:;"
                                    class="btn btn-sm btn-clean btn-icon btn-icon-md"
                                    data-toggle="dropdown"
                                  >
                                    <i class="flaticon-more-1 text-dark"></i>
                                  </a>
                                  <div class="dropdown-menu dropdown-menu-right">
                                    <ul class="navi navi-hover">
                                      <li class="navi-item" v-if="$store.getters.permissions.includes('update_customer')">
                                        <a
                                          class="dropdown-item"
                                          href="javascript:;"
                                          v-on:click="
                                            resetPasswordContactPerson(row)
                                          "
                                          ><i
                                            class="fas fa-redo-alt text-dark mr-3 text-black-50"
                                          ></i
                                          ><span class="text-dark"
                                            >{{$t('reset_password')}}</span
                                          ></a
                                        >
                                      </li>
                                      <li class="navi-item" v-if="row.contact_type !== 'primary' && $store.getters.permissions.includes('switch_contact_person_to_primary')">
                                        <a
                                          class="dropdown-item"
                                          href="javascript:;"
                                          v-on:click="switchContactPersonToPrimary(row)"
                                          ><i
                                            class="fas fa-user text-dark mr-3 text-black-50"
                                          ></i
                                          ><span class="text-dark">{{$t('make_primary')}}</span></a
                                        >
                                      </li>
                                      <li class="navi-item" v-if="$store.getters.permissions.includes('update_customer')">
                                        <a
                                          class="dropdown-item"
                                          href="javascript:;"
                                          v-on:click="editContactPerson(row)"
                                          ><i
                                            class="fas fa-pen text-dark mr-3 text-black-50"
                                          ></i
                                          ><span class="text-dark">{{$t('edit')}}</span></a
                                        >
                                      </li>
                                      <li class="navi-item" v-if="row.contact_type !== 'primary' && row.username !== 'testcustomer' && $store.getters.permissions.includes('delete_customer')">
                                        <a
                                          class="dropdown-item"
                                          href="javascript:;"
                                          v-on:click="
                                            deleteContactPerson(row.id, rindex)
                                          "
                                          ><i
                                            class="fas fa-trash-alt text-dark mr-3 text-black-50"
                                          ></i>
                                          <span class="text-dark">{{$t('delete')}}</span></a
                                        >
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <HtmlTableMobileCards table-id="customer-contacts-table" />
                        <!--end::Section-->
                      </div>
                    </div>
                   </div>
                  </div>
                  <!--begin::Contact person modal component-->
                  <contactPersonModal
                    :user-token="this.$store.state.user.bearerToken"
                    :customer-id="$route.params.id"
                    
                  />
                  <!--end::Contact person modal component-->
                  <resetPassword
                    :user-token="this.$store.state.user.bearerToken"
                    :customer-id="$route.params.id"
                  />
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_3_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_3_9"
                  >
                   <div class="container">
                    <div class="custom-card mb-6">
                      <div class="card-body">
                        <!-- <div class="_4section__content"> -->
                        <div
                          class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap tabContentHeader py-3 pr-2"
                        >
                          <div class="d-flex align-items-center flex-wrap mr-1">
                            <div class="d-flex align-items-baseline flex-wrap">
                              <h5 class="text-dark font-weight-bold">
                                {{$t('shipping')}} {{$t('addresses')}}:
                              </h5>
                            </div>
                          </div>
                          <div class="d-flex align-items-center" v-if="$store.getters.permissions.includes('create_customer')">
                            <button
                              type="button"
                              class="btn btn-success btn-sm"
                              data-toggle="modal"
                              data-target="#shipping_address"
                              v-on:click="triggerAddShippingEvent()"
                              data-backdrop="static" data-keyboard="false"
                            >
                              <i class="fa fa-address-book"></i>{{$t('Add Shipping Address')}}
                            </button>
                          </div>
                        </div>
                        <table
                          class="table text-center table-sm table-head-bg-brand table-bordered" style="width:100%"
                        >
                          <thead class="thead-inverse">
                            <tr>
                              <th class="pl-7" style="width:70%">{{$t('address')}}</th>
                              <th class="text-center" style="width:30%" v-if="$store.getters.permissions.includes('update_customer') || $store.getters.permissions.includes('delete_customer')">{{$t('action')}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(row, rindex) in shippingAddresses"
                              :key="rindex"
                            >
                              <td class="pl-7">{{ addressOneLine(row) }}</td>
                              <td v-if="$store.getters.permissions.includes('update_customer') || $store.getters.permissions.includes('delete_customer')">
                                <div class="text-center">
                                  <span class="text-sm" v-if="$store.getters.permissions.includes('update_customer')" data-toggle="modal" data-target="#shipping_address" @click="triggerEditShippingEvent(row)"><i class="fas fa-edit text-primary mr-1" style="cursor:pointer;"></i></span>
                                  <span class="text-sm" v-if="$store.getters.permissions.includes('delete_customer')" @click="deleteShippingAddress(row.id, rindex)"><i class="fas fa-trash text-danger mr-1" style="cursor:pointer;"></i></span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- </div> -->
                      </div>
                    </div>
                    <addressModal
                      :address-type="'shipping_address'"
                      :modal-title="'Shipping Address'"
                      :customer-id="$route.params.id"
                      v-on:addressToShowCustomer="addressSaveEvent"
                      :parentmessage="parentmessage"
                      :showModal="showShippingAddressModal"
                    />
                    <!--end::Shipping Address Component-->
                    <!--begin: Billing Address Portlet -->
                    <div class="custom-card">
                      <div class="card-body">
                        <div
                          class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap tabContentHeader py-3 pr-2"
                        >
                          <div class="d-flex align-items-center flex-wrap mr-1">
                            <div class="d-flex align-items-baseline flex-wrap">
                              <h5 class="text-dark font-weight-bold">
                                {{$t('billing')}} {{$t('addresses')}}:
                              </h5>
                            </div>
                          </div>
                          <div class="d-flex align-items-center" v-if="$store.getters.permissions.includes('create_customer')">
                            <button
                              type="button"
                              class="btn btn-success btn-sm"
                              data-toggle="modal"
                              data-target="#billing_address"
                              v-on:click="triggerAddBillingEvent(row)"
                              data-backdrop="static" data-keyboard="false"
                            >
                              <i class="fa fa-address-book"></i>{{$t('Add Billing Address')}}
                            </button>
                          </div>
                        </div>
                        <div class="_4section__content">
                          <table
                            class="table table-sm text-center table-head-bg-brand table-bordered" style="width:100%"
                          >
                            <thead class="thead-inverse">
                              <tr>
                                <th class="pl-7" style="width:70%">{{$t('address')}}</th>
                                <th class="text-center" style="width:30%" v-if="$store.getters.permissions.includes('update_customer') || $store.getters.permissions.includes('delete_customer')">{{$t('action')}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, rindex) in billingAddresses"
                                :key="rindex"
                              >
                                <td class="pl-7">{{ addressOneLine(row) }}</td>
                                <td v-if="$store.getters.permissions.includes('update_customer') || $store.getters.permissions.includes('delete_customer')">
                                  <div class="text-center">
                                    <span v-if="$store.getters.permissions.includes('update_customer')" class="text-sm mr-1" data-toggle="modal" data-target="#billing_address" @click="triggerEditBillingEvent(row)"><i class="fas fa-edit text-primary" style="cursor:pointer;"></i></span>
                                    <span v-if="$store.getters.permissions.includes('delete_customer')" class="text-sm mr-1" @click="deleteBillingAddress(row.id, rindex)"><i class="fas fa-trash text-danger" style="cursor:pointer;"></i></span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!--end: Billing Address Portlet -->
                    <!--begin::Shipping Address Component-->
                    <addressModal
                      :address-type="'billing_address'"
                      :modal-title="'Billing Address'"
                      :customer-id="$route.params.id"
                      v-on:addressToShowCustomer="addressSaveEvent"
                      :parentmessage="parentmessage"
                      :showModal="showBillingAddressModal"
                    />
                    <!--end::Shipping Address Component-->
                   </div>
                  </div>
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_4_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_4_9"
                  >
                   <div class="container">
                    <div class="custom-card">
                        <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap tabContentHeader py-3">
                          <div class="d-flex align-items-center flex-wrap ml-1">
                            <div class="d-flex align-items-baseline flex-wrap">
                              <h5 class="text-dark font-weight-bold">{{$t('notes')}}</h5>
                            </div>
                          </div>
                          <div class="d-flex align-items-center" v-if="$store.getters.permissions.includes('create_customer')">
                            <button
                              type="button"
                              class="btn btn-success btn-sm mr-2"
                              data-toggle="modal"
                              data-target="#notes_modal"
                              @click="noteSubmitted = false"
                            >
                              {{$t('add')}} {{$t('note')}}
                            </button>
                          </div>
                        </div>
                      <div class="card-body">
                        
                          <span class="text-dark">
                            {{$t('you_may')}} <code>{{$t('add_remove')}}</code> {{$t('customers')}} {{$t('notes')}} {{$t('from_here')}}
                          </span>
                      
                        <table class="table text-center table-sm table-bordered mt-3">
                          <thead class="thead-inverse">
                            <tr>
                              <th>{{$t('date')}}</th>
                              <th>{{$t('note')}}</th>
                              <th>{{$t('user')}}</th>
                              <th v-if="$store.getters.permissions.includes('delete_customer')">{{$t('action')}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, rindex) in notes?.data" :key="rindex">
                              <td>{{ formatDate(row.created_at)}}</td>
                              <td>{{ row?.note }}</td>
                              <td>{{ row?.user?.role?.name }}</td>
                              <td v-if="$store.getters.permissions.includes('delete_customer')">
                                <div class="dropdown">
                                  <a
                                    href="javascript:;"
                                    class="btn btn-sm btn-clean btn-icon btn-icon-md"
                                    data-toggle="dropdown"
                                  >
                                    <i class="flaticon-more-1 text-dark"></i>
                                  </a>
                                  <div class="dropdown-menu dropdown-menu-right">
                                    <ul class="navi navi-hover">
                                      <li class="navi-item">
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          v-on:click="deleteNote(row.id)"
                                          ><i class="fas fa-trash-alt text-dark mr-3 text-black-50"></i>{{$t('delete')}}</a
                                        >
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                   </div>                 
                  </div>
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_5_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_5_9"
                  >
                   <div class="container">
                    <!--begin::Files Management-->
                    <div class="custom-card">
                      <customerDocument :customer-id="customerId" @file-uploaded="getCustomerDetail"></customerDocument>
                    </div>
                    <!--end::Files Management-->
                    <!-- begin::Files List -->
                    <div class="custom-card mt-8" v-if="filesList.length > 0">
                      <div class="card-header tabContentHeader">
                        <h3 class="card-title text-dark font-weight-bolder">{{$t('uploaded_documents_list')}}</h3>
                        <div class="card-toolbar">
                          <button
                            type="button"
                            class="btn btn-primary active mr-1"
                            v-on:click="getCustomerDetail"
                          >
                            <i class="flaticon2-note text-dark"></i>{{$t('refresh_list')}}
                          </button>
                        </div>
                      </div>
                      <div class="card-body">
                        <!--begin::Section-->
                        <table id="customer-documents-table" class="table text-center table-sm table-bordered">
                          <thead class="thead-inverse">
                            <tr>
                              <th>{{$t('date')}}</th>
                              <th>{{$t('file')}}</th>
                              <th>{{$t('preview')}}</th>
                              <th>{{$t('user')}}</th>
                              <th v-if="$store.getters.permissions.includes('view_customer') || $store.getters.permissions.includes('delete_customer')">{{$t('action')}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, rindex) in filesList" :key="rindex">
                              <td>{{ row.created_at }}</td>
                              <td>{{ row.original_filename }}</td>
                              <td v-if="row.image64 != ''">
                                <img
                                  :src="row.image64"
                                  style="max-width: 80px; max-height: 80px"
                                />
                              </td>
                              <td v-else></td>
                              <td>{{ row.user }}</td>
                              <td v-if="$store.getters.permissions.includes('view_customers') || $store.getters.permissions.includes('delete_customer')">
                                <div class="dropdown">
                                  <a
                                    href="javascript:;"
                                    class="btn btn-sm btn-clean btn-icon btn-icon-md"
                                    data-toggle="dropdown"
                                  >
                                    <i class="flaticon-more-1 text-dark"></i>
                                  </a>
                                  <div class="dropdown-menu dropdown-menu-right">
                                    <ul class="navi navi-hover">
                                      <li class="navi-item" v-if="$store.getters.permissions.includes('view_customers')">
                                          <a class="dropdown-item" href="#" @click="downloadCustomerFile(row.id, row.original_filename)"
                                          ><i class="fa fa-download text-dark mr-3 text-black-50"></i
                                          >{{$t('download')}}</a
                                        >
                                      </li>
                                      <li class="navi-item" v-if="$store.getters.permissions.includes('delete_customer') " >
                                        <a
                                          class="dropdown-item"
                                          href="javascript:;"
                                          v-on:click="deleteFile(row.id, rindex)"
                                          ><i
                                            class="fas fa-trash-alt text-dark mr-3 text-black-50"
                                          ></i>
                                          <span class="text-dark">{{$t('delete')}}</span></a
                                        >
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <HtmlTableMobileCards table-id="customer-documents-table" />
                        <!--end::Section-->
                      </div>
                    </div>
                   </div>  
                  </div>
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_6_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_6_9"
                  >
                   <div class="container">
                    <div class="custom-card">
                      <div class="card-header tabContentHeader  d-flex align-items-center minHeight" >
                        <h5 class="card-title font-weight-bold">{{$t('total_orders')}}</h5>

                        <button v-if="['admin', 'owner','staff'].includes(this.$store.getters.role) && this.$store.getters.permissions.includes('create_order')" @click="goToOrder" class="btn btn-sm btn-success font-weight-bolder ml-1 orderlistButton">
                            {{$t('add_new_order')}}
                        </button>
                      </div>
                      <div class="card-body table-responsive">
                        <!--begin::Section-->
                        <template v-if="orders.length > 0">
                          <table
                            id="customer-orders-table"
                            class="table text-center table-sm table-head-bg-brand table-bordered"
                          >
                            <thead class="thead-inverse">
                              <tr>
                                <th>{{ $t('check_box') }}</th>
                                <th>{{$t('order')}}</th>
                                <th>{{$t('total_amount')}}</th>
                                <th>{{$t('payment_due')}}</th>
                                <th>{{$t('amount_paid')}}</th>
                                <th>{{$t('ship_by_date')}}</th>
                                <th>{{$t('status')}}</th>
                                <th>{{$t('order')}} {{$t('date')}}</th>
                                <th>{{$t('po')}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, rindex) in ordersWithOrderProducts"
                                :key="rindex"
                              >
                              <td>
                                <input type="checkbox" id="checkbox" @change="onFileChange(row, rindex)" :checked="checkBoxVals[rindex]" />
                              </td>
                                <td>
                                  <!-- commenting this router link beacuse we haven't open order router -->
                                  <router-link :to="{name: 'view-order',params: {customer_id: customerId,OrderNumber: row.number}}">#{{ row.number }}</router-link>
                                </td>
                                <td>{{row.brand_currency.currency_symbol}}{{ commaSeprator(row.total_price) }}</td>
                                <td>{{ formatDate(row.payment_due_date)}}</td>
                                <td>{{row.brand_currency.currency_symbol}}{{ commaSeprator(row.paid_amount) }}</td>
                                <template v-if="row.ship_by_date === 'asap'">
                                  <td>{{$t('asap')}}</td>
                                </template>
                                <template v-else>
                                  <td>{{ formatDate(row.ship_by_date) }}</td>
                                </template>
                                <td v-if="row.status == 'approved'">
                                  <span class="label label-lg label-success label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                  <span v-if="(parseFloat(row.total_price) - parseFloat(row.paid_amount)) > 0 && parseFloat(row.paid_amount) != 0" class="label label-lg  label-info label-inline text-capitalize mt-1 mr-1">{{ $t('partially_paid') }}</span>
                                  <span v-else-if="(parseInt(row.total_price) - parseInt(row.paid_amount)) == 0" class="label label-lg label-paid label-inline label-border-radius mb-1 text-capitalize mr-1">{{ $t('paid_in_full') }}</span>
                                  <span v-if="row.invoice_email_sent == '1'" class="label label-lg label-default label-inline label-border-radius mb-1 mr-1">{{ $t('invoiced') }}</span>
                                  <span v-if="row.edited" class="label  label-lg  label-warning label-inline mb-1 mr-1 ">{{ $t('edited') }}</span>
                                </td>
                                <td v-else-if="row.status == 'shipped'">
                                  <span class="label label-lg  label-primary label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                  <span v-if="(parseFloat(row.total_price) - parseFloat(row.paid_amount)) > 0 && parseFloat(row.paid_amount) != 0" class="label label-lg  label-info label-inline text-capitalize mt-1 mr-1">{{ $t('partially_paid') }}</span>
                                  <span v-else-if="(parseInt(row.total_price) - parseInt(row.paid_amount)) == 0" class="label label-lg label-paid label-inline label-border-radius mb-1 text-capitalize mr-1">{{ $t('paid_in_full') }}</span>
                                  <span v-if="row.invoice_email_sent == '1'" class="label label-lg label-default label-inline label-border-radius mb-1 text-capitalize mr-1">{{ $t('invoiced') }}</span>
                                  <span v-if="row.edited" class="label  label-lg  label-warning label-inline mb-1 mr-1">{{ $t('edited') }}</span>
                                </td>
                                <td v-else-if="row.status == 'pending'">
                                  <span class="label label-lg  label-warning label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                  <span v-if="row.invoice_email_sent == '1'" class="label label-lg label-default label-inline label-border-radius mb-1 text-capitalize mr-1">{{ $t('invoiced') }}</span>
                                  <span v-if="row.edited" class="label  label-lg  label-warning label-inline mb-1 mr-1">{{ $t('edited') }}</span>
                                </td>
                                <td v-else-if="row.status == 'completed'">
                                  <span class="label label-lg  label-success label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                </td>
                                <td v-else-if="row.status == 'partially shipped'">
                                  <span class="label label-lg   label-primary label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                  <span v-if="(parseInt(row.total_price) - parseFloat(row.paid_amount)) > 0 && parseFloat(row.paid_amount) != 0" class="label label-info label-inline text-capitalize mt-1 mr-1">{{ $t('partially_paid') }}</span>
                                  <span v-else-if="(parseInt(row.total_price) - parseInt(row.paid_amount)) == 0" class="label paidInFull label-paid label-inline font-weight-lighter text-capitalize mt-1 mr-1">{{ $t('paid_in_full') }}</span>
                                  <span v-if="row.invoice_email_sent == '1'" class="label label-lg label-default label-inline label-border-radius mb-1 text-capitalize mr-1">{{ $t('invoiced') }}</span>
                                  <span v-if="row.edited" class="label  label-lg  label-warning label-inline mb-1 mr-1">{{ $t('edited') }}</span>
                                </td>
                                <td v-else-if="row.status == 'partially paid'">
                                  <span class="label label-lg  label-info label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                  <span v-if="row.invoice_email_sent == '1'" class="label label-lg label-default label-inline label-border-radius mb-1 text-capitalize mr-1">{{ $t('invoiced') }}</span>
                                  <span v-if="row.edited" class="label  label-lg  label-warning label-inline mb-1 mr-1">{{ $t('edited') }}</span>
                                </td>
                                <td v-else-if="row.status == 'rejected'">
                                  <span class="label label-lg  label-danger label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                  <span v-if="row.edited" class="label  label-lg  label-warning label-inline mb-1 mr-1">{{ $t('edited') }}</span>
                                </td>
                                <td v-else>
                                  <span class="label label-lg  label-primary label-inline text-capitalize mr-1">{{
                                    row.status
                                  }}</span>
                                </td>
                                <td>{{ formatDate(row.created_at) }}</td>
                                <td>{{ row.po }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <HtmlTableMobileCards table-id="customer-orders-table" />
                        </template>
                        <template v-else>
                          <div class="noOrdersContent p-5">
                            {{$t('no_orders_for_customer')}}
                          </div>
                        </template>
                        <!--end::Section-->
                      </div>
                    </div>
                   </div>
                  </div>
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_7_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_7_9"
                  >
                   <div class="container">
                    <div class="custom-card">
                      <div class="card-header tabContentHeader  d-flex align-items-center minHeight" >
                        <h5 class="card-title font-weight-bold">{{$t('Total Order Products')}}</h5>
                      </div>
                      <div class="card-body table-responsive">
                        <!--begin::Section-->
                        <template v-if="saleByProducts.length > 0">
                          <table
                            id="customer-order-products-table"
                            class="table text-center table-sm table-head-bg-brand table-bordered"
                          >
                            <thead class="thead-inverse">
                              <tr>
                                <th>{{$t('name')}}</th>
                                <th>{{$t('sku')}}</th>
                                <th>{{$t('Total Quantity Ordered')}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item,index) in saleByProducts" :key="index">
                                <td v-if="item.id != null"><router-link :to="{name: 'view-product',params: {id:item.id} }"> {{ item.name }}</router-link></td>
                                <td v-else>{{ item.name }}
                                  <span class=" flex-shrink-0 tooltip-multiline tooltip-bottom-left ml-1 mt-1" data-toggle="tooltip"
                                      data-placement="left" :data-tooltip="$t('this_product_is_deleted')">
                                      <i class="icon-sl fas fa-info-circle"></i>
                                  </span>
                                </td>
                                <td>{{ item.sku }}</td>
                                <td>{{item.total_quantity}}</td>

                              </tr>
                            </tbody>
                          </table>
                          <HtmlTableMobileCards table-id="customer-order-products-table" />
                        </template>
                        <template v-else>
                          <div class="noOrdersContent p-5">
                            {{$t('No Order Product For Customer')}}
                          </div>
                        </template>
                        <!--end::Section-->
                      </div>
                    </div>
                   </div>
                  </div>
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_8_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_8_9"
                  >
                    <div class="card-body">
                      <div class="custom-card" v-if="$store.state.brand.subdomain !== 'gofericecream'" >
                        <div class="card-header tabContentHeader minHeight">
                          <h5 class="card-title font-weight-bold">{{$t('card_details')}}</h5>
                        </div>
                      </div>
                      <template v-if="isAuthorizeConnected == true">
                        <div v-if="customerAuthorizeNetPaymentInfo && customerAuthorizeNetPaymentInfo.length > 0">
                          <template v-for="(custAuthorizeNetPaymentInfo, index) in customerAuthorizeNetPaymentInfo">
                            <div class="card-header" v-if="custAuthorizeNetPaymentInfo.customer_payment_profile_id" :key="index">
                              <span class="_4section__info">
                                <i class="fa fa-credit-card"></i> {{$t('card_on_file')}}
                                <span>
                                  &nbsp;&nbsp;************
                                  {{ custAuthorizeNetPaymentInfo.card_last_4 }}
                                  &nbsp;&nbsp;<span class="text-muted">{{ $t('exp') }}: </span>
                                  {{ custAuthorizeNetPaymentInfo.card_exp_month }}
                                  /
                                  {{
                                    custAuthorizeNetPaymentInfo.card_exp_year
                                  }}
                                </span>
                              </span>
                                <div class="mr-5 float-right" v-if="$store.getters.permissions.includes('delete_customer')">
                                  <button
                                    type="button"
                                    class="btn btn-danger btn-sm"
                                    @click="
                                      deleteAuthorizeCard(
                                        custAuthorizeNetPaymentInfo.customer_profile_id,
                                        custAuthorizeNetPaymentInfo.customer_payment_profile_id
                                      )
                                    "
                                  >
                                    {{$t('delete')}} {{$t('card')}}
                                  </button>
                                </div>
                                <div class="mr-5 float-right" v-if="custAuthorizeNetPaymentInfo.default_card == 0">
                                  <button
                                    type="button"
                                    class="btn btn-default btn-sm"
                                    @click="
                                      setAuthorizeNetCardAsDefault(
                                        custAuthorizeNetPaymentInfo.customer_profile_id,
                                        custAuthorizeNetPaymentInfo.customer_payment_profile_id
                                      )
                                    "
                                  >
                                    {{$t('set')}} {{$t('default')}}
                                  </button>
                                </div>
                                <div class="mr-5 float-right" v-else>
                                  <span class="btn btn-default btn-sm">{{$t('default')}}</span>
                                </div>
                            </div>
                          </template>
                        </div>
                        <div class="card-header align-items-center" v-else>
                          <span class="_4section__info"><i class="fa fa-credit-card"></i>{{$t('no_credit_card_file')}}</span>
                        </div>
                        <div class="card-body" v-if="$store.getters.permissions.includes('create_customer') || $store.getters.permissions.includes('update_customer')">
                          <div class="form-group row">
                            <div class="col-md-6">
                              <label class="control-label">{{$t('card_number')}}*</label>
                              <div class="input-group form-text">
                                <div class="input-group-prepend">
                                  <span class="input-group-text"
                                    ><i class="fab fa-cc-amex"></i
                                  ></span>
                                </div>
                                <input
                                  ref="cardNumInput"
                                  :data-error="cardErrors.cardNumber ? true : false"
                                  v-model="cardNumber"
                                  type="tel"
                                  :class="{'form-control': true,'borderr': cardErrors.cardNumber}"
                                  validate="{required:true}"
                                  placeholder="################"
                                />
                              </div>
                              <span
                                v-if="cardErrors.cardNumber"
                                class="danger"
                              >
                                <small>{{ cardErrors.cardNumber }}</small>
                              </span>
                            </div>
                            <div class="col-md-6">
                              <label class="control-label">{{$t('expiration_date')}}*</label>
                              <input
                                ref="cardExpInput"
                                id="card-exp"
                                :data-error="cardErrors.cardExpiry ? true : false"
                                v-model="cardExpiry"
                                :class="{'form-control': true,'borderr': cardErrors.cardNumber}"
                                validate="{required:true}"
                                @input="formatCardExpiry"
                                placeholder="MM / YY"
                                class="mt-1"
                              />
                              <span
                                v-if="cardErrors.cardExpiry"
                                class="danger"
                              >
                                <small>{{ cardErrors.cardExpiry }}</small>
                              </span>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-md-6">
                              <label class="control-label">{{$t('cvc')}}*</label>

                              <input
                                ref="cardCvcInput"
                                :data-error="cardErrors.cardCvc ? true : false"
                                v-model="cardCvc"
                                :class="{'form-control': true,'borderr': cardErrors.cardNumber}"
                                validate="{required:true}"
                                @input="formatCardCVC"
                                :placeholder="$t('cvc')"
                              />
                              <span v-if="cardErrors.cardCvc" class="danger">
                                <small>{{ cardErrors.cardCvc }}</small>
                              </span>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="isStripeConnected == true">
                        <div class="custom-card">
                          <div class="card-body">
                            <div class="form-group">
                              <stripe-billing-management
                                :customerId="customerId"
                                :customerType="customerType"
                                :CONNECTED_STRIPE_ACCOUNT_ID="CONNECTED_STRIPE_ACCOUNT_ID"
                              ></stripe-billing-management>
                            </div>
                          </div>
                        </div>
                        <div class="custom-card mt-5" v-if="brandCurrencyCode == 'USD'">
                          <div class="card-header tabContentHeader">
                            <h5 class="card-title font-weight-bold">{{$t('bank_accont_details')}}</h5>
                          </div>
                          <div class="card-body">
                            <div class="form-group">
                              <stripe-bank-account-management
                                :customerId="customerId"
                                :customerType="customerType"
                                :country="country"
                                :currency="currency"
                                :CONNECTED_STRIPE_ACCOUNT_ID="CONNECTED_STRIPE_ACCOUNT_ID"
                              ></stripe-bank-account-management>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="isSquareConnected == true">
                        <div class="card-body">
                          <div class="form-group">
                            <square-card-billing :key="componentKey"
                              :customerId="customerId"
                            ></square-card-billing>
                          </div>
                        </div>
                      </template>
                      <!-- Payflow Pro card details section -->

                      <template v-else-if="isPayflowConnected && customerPayflowPaymentInfo != null">
                        <div class="card card-header mb-2" style="justify-content: center;">
                          <span class="_4section__info pl-4"><i class="fa fa-credit-card"></i>
                            <span class="typo"> {{$t('card_on_file')}}:</span>
                            <span class="typo">
                              &nbsp;&nbsp;************ {{ customerPayflowPaymentInfo.card_last_4 }} &nbsp;&nbsp;<span class="text-muted">{{ $t('exp') }}: </span>
                              {{ customerPayflowPaymentInfo.card_exp_month }} / {{ customerPayflowPaymentInfo.card_exp_year }}
                            </span>
                            <span class="mr-5 float-right" v-if="$store.getters.permissions.includes('delete_customer')">

                                <button type="button" class="btn btn-danger btn-sm position-btn" @click="deletePayflowCard(customerPayflowPaymentInfo.customer_profile_id, customerPayflowPaymentInfo.customer_payment_profile_id)">
                                {{$t('delete')}} {{$t('card')}}
                                </button>

                            </span>
                          </span>
                        </div>
                      </template>
                      <!-- ends Payflow Pro  card details section -->

                      <template v-else>
                        <div class="card-body" v-if="$store.getters.permissions.includes('create_customer') || $store.getters.permissions.includes('update_customer')">
                          <div class="form-group row">
                            <div class="col-md-6">
                              <label class="control-label">{{$t('card_number')}}*</label>
                              <div class="input-group form-text">
                                <div class="input-group-prepend">
                                  <span class="input-group-text"
                                    ><i class="fab fa-cc-amex"></i
                                  ></span>
                                </div>
                                <input
                                  ref="cardNumInput"
                                  :data-error="cardErrors.cardNumber ? true : false"
                                  v-model="cardNumber"
                                  type="tel"
                                  class="form-control"
                                  placeholder="#### #### #### ####"
                                  @input="formatCardNumber"
                                />
                              </div>
                              <span
                                v-if="cardErrors.cardNumber"
                                class="invalid-feedbacks"
                              >
                                <small>{{ cardErrors.cardNumber }}</small>
                              </span>
                            </div>
                            <div class="col-md-6">
                              <label class="control-label">{{$t('expiration_date')}}*</label>
                              <input
                                ref="cardExpInput"
                                id="card-exp"
                                :data-error="cardErrors.cardExpiry ? true : false"
                                v-model="cardExpiry"
                                class="form-control form-text"
                                @input="formatCardExpiry"
                                placeholder="MM / YY"
                              />
                              <span
                                v-if="cardErrors.cardExpiry"
                                class="invalid-feedbacks"
                              >
                                <small>{{ cardErrors.cardExpiry }}</small>
                              </span>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-md-6">
                              <label class="control-label">{{$t('cvc')}}*</label>

                              <input
                                ref="cardCvcInput"
                                :data-error="cardErrors.cardCvc ? true : false"
                                v-model="cardCvc"
                                class="form-control form-text"
                                @input="formatCardCVC"
                                :placeholder="$t('cvc')"

                              />
                              <span v-if="cardErrors.cardCvc" class="invalid-feedbacks">
                                <small>{{ cardErrors.cardCvc }}</small>
                              </span>
                            </div>
                          </div>
                        </div>
                      </template>
                      <div class="card-footer">
                        <div class="card-toolbar">
                          <div class="row">
                            <div class="col-lg-12 d-flex justify-content-end" v-if="$store.getters.permissions.includes('create_customer')">
                              <template v-if="isAuthorizeConnected == true">
                                <button
                                  type="button"
                                  class="btn btn-success mr-2"
                                  @click="saveAuthorizeCard"
                                >
                                  {{$t('save')}}
                                </button>
                                <button
                                  type="reset"
                                  class="btn btn-secondary"
                                  @click="resetCard"
                                >
                                  {{$t('cancel')}}
                                </button>
                              </template>
                              <template v-if="isPayflowConnected == true && customerPayflowPaymentInfo == null">
                                <button
                                  type="button"
                                  :class="{'btn btn-sm btn-primary mr-1' : true , 'spinner spinner-white spinner-right disabled' : this.spinner }"
                                  @click="savePayflowCard"
                                >
                                  {{ $t('save') }}
                                </button>
                                <button
                                  type="reset"
                                  class="btn btn-sm btn-secondary ml-1"
                                  @click="resetCard"
                                >
                                  {{$t('reset')}}
                                </button>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--end::Payment Info Management-->
                  </div>
                  <div
                    v-if="status == 'active'"
                    class="tab-pane fade"
                    id="kt_tab_pane_9_9"
                    role="tabpanel"
                    aria-labelledby="kt_tab_pane_9_9"
                  >
                  <div class="container">
                    <div class="custom-card">
                      <div class="card-header tabContentHeader  d-flex align-items-center minHeight" >
                        <h5 class="card-title font-weight-bold">{{$t('add_new_notifications_email')}}</h5>
                      </div>
                      <div class="card-body">
                        <Form @submit="saveNotificationEmail" :validation-schema="schema" v-slot="{errors}">
                        <div class="form-group row">
                            <div class="col-md-5 col-sm-10 px-0 ml-4 pt-1">
                              <Field type="email" name="addNotificationEmail" v-model="addNotificationEmail" :placeholder="$t('enter_email')" class="form-control form-elements" :class="{ 'is-invalid': errors.addNotificationEmail }"/>
                              <ErrorMessage name="addNotificationEmail" class="error-message"/>
                            </div>
                            <div class="form-text col-md-2 col-sm-2" >
                                <button type="submit" :class="{'btn btn-success':true}" :disabled="this.spinner">{{$t('add')}}</button>
                            </div>
                            <span class="col-lg-4 invalid-feedback"></span>
                        </div>
                      </Form>
                      </div>
                    </div>
                    
                    <div class="custom-card mt-7">
                        <div class="card-header tabContentHeader  d-flex align-items-center minHeight">
                            <span class="card-title font-weight-bold font-size-h5">{{$t('notification_emails_list')}}</span>
                        </div>
                        <div class="card-body">
                          <table class="table table-sm table-head-bg-brand table-bordered">
                            <thead class="thead-inverse">
                              <tr>
                                <th class="font-weight-bolder">{{ $t('notification') }} {{ $t('emails') }}</th>
                                <th v-if="notificationEmails.length > 1" class="text-center">{{ $t('action') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, rindex) in notificationEmails" :key="rindex">
                                <td v-if="notificationEmails.length > 0">{{ row.email }}</td>
                                <td v-if="notificationEmails.length > 1">
                                  <div class="dropdown text-center">
                                    <a href="javascript:;" class="btn btn-sm btn-clean btn-icon btn-icon-md" data-toggle="dropdown">
                                        <i class="flaticon-more-1 text-dark mr-2"></i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" href="#" @click="deleteNotificationEmail(row)" @click.prevent="formReset"><i class="fa fa-trash-alt mr-2 text-dark"></i> {{ $t('delete') }}</a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                              <!-- <vue-bootstrap-table
                                :columns="columns"
                                :values="notificationEmails"
                                :show-column-picker="false"
                                :paginated="true"
                                :pageSize="10"
                                :multiple="false"
                                :selectable="false"
                                :row-click-handler="handleRowFunction"
                                class="text-center"
                              >
                              </vue-bootstrap-table> -->
                        </div>
                    </div>
                  </div>
                  </div>
                </div>
                <Referal></Referal>
              </div>
            </div>
          </div>
          <!-- begin::Store Credit Modal -->
          <div
            class="modal fade show"
            id="store_credit_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="storeCreditModalLabel"
            aria-hidden="true"
          >
          <Form @submit="validateCustomerStoreCreditBeforeSubmit" :validation-schema="storeCreditSchema" v-slot="{ errors }">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bolder">{{$t('store_credit')}}</h5>
                  <button type="button" class="close" data-dismiss="modal" :aria-label="$t('close')"></button>
                </div>
                <div class="modal-body">
                  <div class="form-group row">
                    <div class="col-lg-12">
                      <label>{{$t('store_credit')}}*</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{brand_currency_symbol}}</span>
                        </div>
                        <Field 
                          type="number" 
                          name="amount" 
                          v-model="credit_amount" 
                          placeholder="" 
                          class="form-control form-elements" 
                          :class="{ 'is-invalid': errors.amount }"
                        />
                      </div>
                      <ErrorMessage name="amount" class="error-message"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-12">
                      <label>{{$t('note')}}</label>
                      <div class="input-group">
                        <Field 
                          as="textarea" 
                          name="note" 
                          v-model="credit_note" 
                          class="form-control form-elements" 
                          :class="{ 'is-invalid': errors.note }" 
                          style="margin-top: 0px; margin-bottom: 0px; height: 109px"
                        />
                        <ErrorMessage name="note" class="error-message"/>
                      </div>
                    </div>
                  </div>
                  <span class="form-text text-muted">{{$t('credit_applied_text')}}</span>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    {{$t('close')}}
                  </button>
                  <button 
                    type="submit" 
                    :class="{ 'btn btn-primary': true }" 
                    :disabled="buttonDisable"
                  >
                    {{$t('save')}}
                  </button>
                </div>
              </div>
            </div>
          </Form>      
          </div>
          <!-- end::Store Credit Modal-->
          <!-- begin::Products In Cart Modal -->
          <div
            class="modal fade show"
            id="products_in_cart_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="storeCreditModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bolder">{{$t('products_in_cart')}}:</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    :aria-label="$t('close')"
                  ></button>
                </div>
                <div class="modal-body">
                  <div class="_4portlet__body">
                    <!--begin::Section-->
                    <div class="_4section">
                      <div class="_4section__content">
                        <div>
                          <div
                            style="display: center; font-size: 1rem"
                            v-if="!totalCartProducts"
                          >
                            <p class="font-weight-bolder text-muted">{{$t('no_products_in_cart')}}</p>
                          </div>
                          <table
                            class="table text-center table-sm table-head-bg-brand"
                            v-else
                          >
                            <thead class="thead-inverse">
                              <tr>
                                <th>{{$t('product')}} {{$t('names')}}</th>
                                <th>{{$t('quantity')}}</th>
                                <th>{{$t('sku')}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, rindex) in cartProducts"
                                :key="rindex"
                              >
                                <td>{{ row.name }}</td>
                                <td>{{ commaSeprator(row.quantity) }}</td>
                                <td>{{ row.sku }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!--end::Section-->
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                  >
                    {{$t('close')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- end::Products In Cart Modal-->
          <div
            class="modal fade show"
            id="notes_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="notesModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bolder" id="exampleModalLabel">{{$t('customer')}} {{$t('note')}}</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    :aria-label="$t('close')"
                  ></button>
                </div>
                <div class="modal-body validated">
                    <label class="font-weight-bolder">{{$t('note')}}:</label>
                  <textarea
                    class="form-control form-elements"
                    id="note"
                    name="note"
                    v-validate="{
                      required: true,
                    }"
                    v-model="note"
                    data-vv-as="Customer Note"
                    data-vv-scope="note"
                    style="margin-top: 0px; margin-bottom: 0px; height: 109px"
                  ></textarea>
                  <span v-if="(!note || note.trim() === '') && noteSubmitted"
                  class="text-danger mt-1 d-block">
                    {{ $t('note_is_required') }}
                  </span>
                  <!-- <span class="invalid-feedback">{{errors.first("note.note") }}</span> -->
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    {{$t('close')}}
                  </button>
                  <button
                    type="button"
                    :class="{
                      'btn btn-primary': true,
                      '_4spinner _4spinner--v2 _4spinner--right _4spinner--sm _4spinner--primary disabled': this
                        .spinner,
                    }"
                    :disabled="buttonDisable"
                    v-on:click="saveCustomerNote"
                  >
                    {{$t('save')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Vue from "vue";
import CustomerAPIService from "@/js/api/customers/customers";
import ContactPersonAPIService from "@/js/api/customers/contact-persons";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueCardFormat from "vue-credit-card-validation";
import VueBootstrapTable from "vue2-bootstrap-table2";
import PriceTierAPIService from "@/js/api/price-tiers/price-tiers";
import Referal from '@/js/ordercircle/brands/orders/friendReferal.vue';
import AccountSettingAPIService from '@/js/api/settings/account-setting';
import squareCardBillingComponent from "@/js/ordercircle/brands/components/SquareCardBillingManagement.vue";
import stripeBillingComponent from "@/js/ordercircle/brands/components/StripeBillingManagement.vue";
import stripeBankAccountComponent from "@/js/ordercircle/brands/components/StripeBankAccountManagement.vue";
import resetPassword from "@/js/ordercircle/brands/customers/reset-password-contact-modal.vue";
import contactPersonModal from "@/js/ordercircle/layouts/components/customers/contact-person-modal.vue";
import addressModal from "@/js/ordercircle/layouts/components/address/address.vue";
import customerDocument from "@/js/ordercircle/layouts/components/customers/document.vue";
import HtmlTableMobileCards from "@/js/ordercircle/components/HtmlTableMobileCards.vue";
import { Field, Form, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import store from "@/js/store.js";
import eventBus from '@/js/utils/eventBus';

var notificationEmailLength = 0;
var isVisible= store.state.permissions.includes('delete_customer')
// Vue.use(VueCardFormat);

export default {
  name: "ShowCustomer",
  props: {},
  components: {
    vueDropzone: () =>
      import(/* webpackChunkName: "customers" */ "vue2-dropzone"),
    // 'stripe-management': stripeComponent,
    VueBootstrapTable: VueBootstrapTable,
    "stripe-billing-management": stripeBillingComponent,
    "stripe-billing-management": (store.state.brand.subdomain == 'gofericecream') ? {} : stripeBillingComponent,
    "stripe-bank-account-management": stripeBankAccountComponent,
    "square-card-billing": squareCardBillingComponent,
    Referal,
    resetPassword,
    contactPersonModal,
    addressModal,
    Form,
    Field,
    ErrorMessage,
    customerDocument,
    HtmlTableMobileCards
  },
  data() {
    return {
      /**
       *  Stats
       */
      componentKey: 0,
      totalSpend: '0',
      totalOrders: '',
      lastOrderDate: '',
      outstandingInvoices: '',
      outstandingBalance: '',
      credit_limit: '',
      /**
       *  Others
       */
      addNotificationEmail:'',
      showBillingAddressModal: false,
      showShippingAddressModal: false,
      company_name: "",
      username: "",
      name: "",
      email: "",
      phone_number: "",
      brand_price_tier: "",
      brand_promo_code: "",
      minimum_order: "",
      maximum_order: "",
      days_invoices_due: "",
      tax_id: "",
      tax_rate: "",
      rep_name: "House Account (No Rep)",
      login_enabled: 0,
      send_order_emails: 0,
      require_payment_info: 0,
      orderNumber: [],
      contact_persons: [],
      orders: [],
      ordersWithOrderProducts: [],
      price_tiers_options: [],
      rep_options: [],
      notes: [],
      totalNotes: [],
      shippingAddresses: [],
      billingAddresses: [],
      parentmessage: "",
      customerId: this.$route.params.id,
      customerType: "customer", // This could be dynamic and represent the type of customer (customer, staff or owner)
      status: "",
      quickbooks_status: '',
      quickbooks_customer_name: '',
      cin7_status: '',
      cin7_customer_name: '',
      xero_status: '',
      xero_customer_name: '',
      hubspot_status: '',
      hubspot_customer_name: '',
      // Store Credit
      credit_amount: 0,
      credit_note: "",
      notificationEmails: [],
      cartProducts: [],
      totalCartProducts: 0,
      // users: [],
      contactPersons: [],
      spinner: false,
      buttonDisable: false,
      Order_Numbers: [],
      deleted_at: "",
      note: "",
      noteSubmitted: false,
      dateAdded: "",
      customerLastLogin: "",
      allow_card_payment: "",
      add_days_to_due_date_on_ship: 0,
      brandCurrency: '',
      brand_currency_symbol: '',
      brand_currency_code: '',
      loginEnabled: 0,
      showRemoveButton:true,
      customerTags: [],
      // file
      filesList: [],
      uploadButtonDisabled:true,
      dropzoneOptions: {
        url: CustomerAPIService.customersFiles(this.$route.params.id),
        addRemoveLinks: true,
        dictDefaultMessage:
          "<i class='fa fa-cloud-upload'></i>UPLOAD FILES/IMAGES",
        thumbnailWidth: 200,
        maxFilesize: 5,
        autoProcessQueue: false,
        acceptedFiles: "image/*,.pdf,.xlsx,.xls,.doc,.docx,.csv,.heic",
        maxFiles: 2,
        headers: {
          Authorization: "Bearer " + this.$store.state.user.bearerToken,
        },
        success(file, response) {
          swal.fire("Success!", "Files successfully uploaded and saved.", "success");
          this.removeFile(file);
          //this.getFiles();
        },
        error(file) {
          this.notify(
            "Error Exception!",
            "Something went wrong to upload file " +
              file.name +
              "<br/> Please try again!",
            "error"
          );
          //this.removeFile(file); // Not removing it just because user could see the erroneous file and then manually delete it.
        },
        maxfilesexceeded: function (file) {
          swal.fire("Error Exception!", "You can't upload more files", "error");
          this.removeFile(file);
        },
      },

      // Payment Info Data
      cardNumber: "",
      cardCvc: "",
      cardExpiry: "",
      cardErrors: {},
      // $cardFormat: Vue.prototype.$cardFormat,

      isPayflowConnected: false,
      isAuthorizeConnected: false,
      isPaylianceConnected: false,
      isStripeConnected: false,
      isSquareConnected: false,
      customerAuthorizeNetPaymentInfo: "",
      customerPayflowPaymentInfo: "",
      warehousesCount: 0,
      columns: [
        {
          name: "email",
          title: this.$t('notification_emails'),
          columnstyle: 'text-left',
          cellstyle: "text-left",
        },
        {
          name: "Actions",
          title: this.$t('actions'),
          columnstyle: 'text-center',
          cellstyle: "text-center",
          sortable: false,
          renderfunction(index, row) {
            if (row.contact_type !== "primary" && isVisible) {
              if (notificationEmailLength > 1 ) {
                return '<button class = "btn btn-danger btn-icon delete-notification-email" href="javascript:;"><i class="la la-trash delete-notification-email"></i></button>';
              }
            } else {
              return "N/A";
            }
          },
        },
      ],
      country: "US", // TODO: Used for stripe bank account, need to make it dynamic
      currency: "USD", // TODO: Used for stripe bank account, need to make it dynamic
      warehouse:"",
      checkBoxVals:[],
      combineOrdersData:[],
      saleByProducts:[],
      allow_card_payment: "",
      add_days_to_due_date_on_ship: 0,
      customFieldValue: '',
      customFieldText: '',
      isLicenseBrand: this.$store.state.brand.subdomain === 'slaps',
    };
  },
  computed: {
    expiration_months() {
      return Array.from({ length: 12 }, (value, index) => 1 + index);
    },
    expiration_years() {
      const year = new Date().getFullYear();
      return Array.from({ length: 10 }, (value, index) => year + index);
    },
    schema () {
      return yup.object ({
        addNotificationEmail: yup.string().required('Email is required').email('Email is not valid'),
      })
      },
    storeCreditSchema () {
      return yup.object({
        amount:yup.number().required('Store Credit is required').transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value)),
      })
    },
  },
  watch: {
    // handle auto-focus to next field
    // Note: since CVC can be 3 OR 4 digits we don't watch it
    // cardNumber: function (val) {
    //   if (this.$cardFormat.validateCardNumber(val)) {
    //     this.$refs.cardExpInput.focus();
    //   }
    // },
    // cardExpiry: function (val) {
    //   if (this.$cardFormat.validateCardExpiry(val)) {
    //     this.$refs.cardCvcInput.focus();
    //   }
    // },
  },
  async mounted(){
   await this.getCustomerDetail();
   eventBus.on('contactPersonSaveEvent', () => {
    this.contactSaveEvent()
   });
  },
  methods: {
    async getCustomerDetail() {
      this.$store.commit('SHOW_LOADER',true);
      CustomerAPIService.getCustomerData(this.$route.params.id).then((response) => {
        if (response.data.hasOwnProperty("success")) {
          if (response.data.customerDetails && response.data.customerDetails.customer) {
            this.company_name = response.data.customerDetails.customer.company_name;
            this.phone_number = response.data.customerDetails.customer.phone_number;
            this.brand_price_tier = response.data.customerDetails.customer.brand_price_tier.name;
             if (
               response.data.customerDetails.promoCode !== null &&
               response.data.customerDetails.promoCode !== undefined
             ) {
               this.brand_promo_code = response.data.customerDetails.promoCode;
             }
            if (
              response.data.customerDetails.promoCode !== null &&
              response.data.customerDetails.promoCode !== undefined
            ) {
              this.brand_promo_code = response.data.customerDetails.promoCode;
            }
            this.brandCurrencyCode = response.data.customerDetails.brandCurrency[0].brand_currency_code;
            this.brandCurrency = response.data.customerDetails.brandCurrency[0].brand_currency_title;
            this.brand_currency_symbol = response.data.customerDetails.brandCurrency[0].brand_currency_symbol;
            this.orderNumber = response.data.customerDetails.orders.data;
            this.Order_Numbers = this.orderNumber.map((value) => value.number);
            this.minimum_order = response.data.customerDetails.customer.minimum_order;
            this.deleted_at = response.data.customerDetails.customer.deleted_at;
            this.maximum_order = response.data.customerDetails.customer.maximum_order;
            this.days_invoices_due = response.data.customerDetails.customer.days_invoices_due;
            this.tax_id = response.data.customerDetails.customer.tax_id;
            this.tax_rate = response.data.customerDetails.customer.tax_rate != null ? (response.data.customerDetails.customer.tax_rate * 100).toFixed(2) : (this.$store.getters.brand['tax_rate']* 100).toFixed(2);
            this.cartProducts = response.data.customerDetails.cartProducts;
            this.totalCartProducts = response.data.customerDetails.totalCartProducts;
            this.customerTags = response.data.customerDetails.customerTags;
            if (response.data.customerDetails.customer.rep !== null) {
              this.rep_name = response.data.customerDetails.customer.rep.name;
            }
            this.send_order_emails = response.data.customerDetails.customer.send_order_emails;
            this.require_payment_info = response.data.customerDetails.customer.require_payment_info;
            this.allow_card_payment = response.data.customerDetails.customer.allow_card_payment;
            this.add_days_to_due_date_on_ship = response.data.customerDetails.customer.add_days_to_due_date_on_ship;
            this.login_enabled = response.data.customerDetails.customer.login_enabled;
            this.dateAdded = response.data.customerDetails.customer.created_at;
            // this.contact_persons = response.data.customer.contact_persons;
            this.orders = response.data.customerDetails.orders.data;
            this.ordersWithOrderProducts =response.data.customerDetails.ordersWithOrderProducts;
            this.saleByProducts =response.data.customerDetails?.saleByProducts;
            this.totalOrders = response.data.customerDetails.totalOrders;
            this.status = response.data.customerDetails.customer.status;
            this.credit_limit = (response.data.customerDetails.customer.credit_limit != null) ? response.data.customerDetails.customer.credit_limit : this.$store.getters.brand['customer_credit_limit_amount'] ;
            this.customFieldValue = response.data.customerDetails?.customer?.custom_field_value;
            this.customFieldText= response.data.settings?.customCustomerField;
            this.quickbooks_status = response.data.customerDetails.quickbooksStatus;
            this.quickbooks_customer_name = response.data.customerDetails.quickbooksCustomerName;
            this.cin7_status = response.data.customerDetails.cin7Status;
            this.cin7_customer_name = response.data.customerDetails.cin7CustomerName || this.$t('not_linked');
            this.xero_status = response.data.customerDetails.xeroStatus;
            this.xero_customer_name = response.data.customerDetails.xeroCustomerName;
            this.hubspot_status = response.data.customerDetails.hubspotStatus;
            this.hubspot_customer_name = response.data.customerDetails.hubspotCustomerName || this.$t('not_linked');
            this.notificationEmails = response.data.customerDetails.customer.notification_emails;
            let email = 0
            this.notificationEmails.forEach(function(index){index.email});
            notificationEmailLength = this.notificationEmails.length;
            // this.users = response.data.customerDetails.customer.user;
            this.totalSpend           = response.data.customerDetails.totalSpend;
            this.totalOrders          = response.data.customerDetails.totalOrders;
            this.lastOrderDate        = response.data.customerDetails.lastOrderDate;
            this.outstandingInvoices  = response.data.customerDetails.outstandingInvoices;
            this.outstandingBalance   = response.data.customerDetails.outstandingBalance;

            // Brand Owner Stripe Connected id used in StripeBillingManagent.vue component.
            this.CONNECTED_STRIPE_ACCOUNT_ID = response.data.customerDetails.connected_stripe_account;
            this.warehouse = response.data?.customerDetails?.customer?.warehouse?.hasOwnProperty('name') ? response.data.customerDetails.customer.warehouse.name : "" ;
            this.warehousesCount = response.data.customerDetails.warehousesCount;
          }
          if (typeof response.data.customerDetails.creditNote !== "undefined") {
            this.credit_amount = response.data.customerDetails.creditNote.amount;
            this.credit_note = response.data.customerDetails.creditNote.note;
          }
          if (typeof response.data.customerDetails.paymentInfo !== "undefined") {
            this.isPayflowConnected = response.data.customerDetails.paymentInfo.isPayflowConnected;
            this.isAuthorizeConnected = response.data.customerDetails.paymentInfo.isAuthorizeConnected; // Have to remove hard coding.
            this.isPaylianceConnected = response.data.customerDetails.paymentInfo.isPaylianceConnected;
            this.isStripeConnected = response.data.customerDetails.paymentInfo.isStripeConnected;
            this.customerAuthorizeNetPaymentInfo =
              response.data.customerDetails.paymentInfo.customerAuthorizeNetPaymentInfo;
            this.isSquareConnected = response.data.customerDetails.paymentInfo.isSquareConnected;
          }
          if (response.data.hasOwnProperty("customerPriceTier")) {
            this.price_tiers_options = response.data.customerPriceTier;
          }
          if(response.data.hasOwnProperty("customerNotes")) {
            this.notes = response.data.customerNotes.notes;
            this.totalNotes = response.data.customerNotes.totalNotes;
          }
          if(response.data.hasOwnProperty("customerFiles")) {
            this.filesList = response.data.customerFiles;
          }
          if(response.data.hasOwnProperty("shippingAddresses")) {
            this.shippingAddresses = response.data.shippingAddresses;
          }
          if(response.data.hasOwnProperty("billingAddresses")) {
            this.billingAddresses = response.data.billingAddresses;
          }
          this.componentKey += 1
          if(response.data.hasOwnProperty("customerContact")) {
            this.contactPersons = response.data.customerContact;
            this.loginEnabled = this.contactPersons[0].login_enabled;
            this.customerLastLogin = this.contactPersons[0].last_login;
            // this.users = response.data.customerContact.user;
          }
          if (typeof response.data.brandReps !== "undefined") {
            this.rep_options = response.data.brandReps;
          }
          if(response.data.hasOwnProperty("customerStates")) {
            this.states = response.data.customerStates;
          }
          if(response.data.hasOwnProperty("customerPayflowPaymentInfo")) {
            this.customerPayflowPaymentInfo = response.data.customerPayflowPaymentInfo;
          }
          this.$store.commit('SHOW_LOADER',false);
        } else if (response.data.hasOwnProperty("error")) {
          this.$store.commit('SHOW_LOADER',false);
          this.notify("Error", response.data.error, "error");
        }
      }).catch((error) => {
        this.$store.commit('SHOW_LOADER',false);
        if(error.response){
          this.notify("Error Exception!", error.response, "error");
        }
        // Bugsnag.notify(error);
      });
    },
    formatCardNumber() {
    this.cardNumber = this.cardNumber.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, "$1 ").slice(0, 19);
    },
    
    formatCardExpiry() {
      let value = this.cardExpiry.replace(/\D/g, '');
      
      if (value.length >= 2) {
        value = value.substring(0, 2) + '/' + value.substring(2, 4);
      }
      
      this.cardExpiry = value;
    },
    
    formatCardCVC() {
      this.cardCvc = this.cardCvc.replace(/\D/g, '').slice(0, 4);
    },
    onFileChange(row, index) {
      this.checkBoxVals[index] = !this.checkBoxVals[index];
      
      if (this.checkBoxVals[index]) {
        this.combineOrdersData.push(row.number);
      } else {
        const rowIndex = this.combineOrdersData.indexOf(row.number);
        if (rowIndex !== -1) {
          this.combineOrdersData.splice(rowIndex, 1);
        }
      }
    },
    // deleteNotificationEmails(row, rindex) {
    //   Swal.fire({
    //     title: 'Are you sure you want to delete this?',
    //     icon: 'warning',
    //     confirmButtonColor: '#3085d6',
    //     confirmButtonText: 'Yes',
    //     allowOutsideClick: false,
    //     showCancelButton: true,
    //     cancelButtonColor: '#d33',
    //   }).then((result) => {
    //     if (result.value) {
    //       AccountSettingAPIService.deleteNotificationEmail(row.id, row.customer_id, this.access_token)
    //         .then((response) => {
    //           if (response.data.success) {
    //             Swal.fire('Deleted!', 'Your Notification Email has been deleted.', 'success');
    //             this.notificationEmail.splice(rindex, 1);
    //             this.getNotificationsEmail();
    //           } else if (response.data.error) {
    //             Swal.fire("Error!", response.data.error, "error");
    //           }
    //         }).catch(() => {
    //             Swal.fire("Error Exception!", "Error", "error");
    //         });
    //     }
    //   });
    // },
    combineInvoices(){
        let data = {
                orderNumbersList: this.combineOrdersData,
            };
        this.$store.commit('SHOW_LOADER',true);
        CustomerAPIService.getCombineInvoices(
            this.$route.params.id,
            data,
        ).then((response) => {
            this.$store.commit('SHOW_LOADER',false);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'combine-invoice.pdf');
            document.body.appendChild(link);
            link.click();
            this.changeQuantityCheck == false
        }).catch((error) => {
            this.$store.commit('SHOW_LOADER',false);
            this.notify("Error Exception", error.response.data, "error");
        });
    },
    saveNotificationEmail(){
      let data = {
        email : this.addNotificationEmail,
        id : this.$route.params.id
      };
      CustomerAPIService.addNotificationEmail(data).then((response)=>{
        if(response.data.hasOwnProperty('success')){
          this.spinner = false;
          this.notify('Success','Notification email created successfully','success');
          // this.addNotificationEmail = '',
          this.getCustomerDetail();
        }else if(response.data.hasOwnProperty('error')){
          this.spinner = false;
          this.notify('Error',response.data.error['email'][0],'error');
        }
      }).catch((error)=>{
        this.spinner = false;
        this.notify('Error','Exception Error!','error');
      });
    },
    dateFormatter(str){
      str = str.trim().split(' '); //seprating date and time
      let split = str[0].split('-'); //spliting date
      let start = split[1] + '-' + split[2] + '-' +split[0]; //adding '-' and changing format 09-07-2021
      let finalstr=start + ' '+ str[1] + ' ' +str[2]; //09-07-2021 10:28:19 am
      return finalstr;
    },
    fileUpload(){
      this.uploadButtonDisabled = false;
      this.showRemoveButton = false;
    },
    disabledButtons(){
        this.uploadButtonDisabled = true;
    },
    uploadSuccess: function (file, response) {
      this.getCustomerDetail();
      this.uploadButtonDisabled = true;
      this.showRemoveButton = true;
    },
    processImage: function () {
      this.$refs.myVueDropzone.processQueue();
    },
    removeAllFiles() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.showRemoveButton = true;
      this.uploadButtonDisabled = true;
    },
    deleteFile: function (fileId, fileIndex) {
      var self = this;
      swal
        .fire({
          title: this.$t('sure_you_want_to_delete_this_file'),
          text: this.$t('action_cannot_be_reverted'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then(function (result) {
          if (result.value) {
            CustomerAPIService.deleteCustomerFile(
              self.$route.params.id,
              fileId)
              .then((response) => {
                swal.fire("Deleted!", "Your File has been deleted.", "success");
                self.filesList.splice(fileIndex, 1);
              })
              .catch((error) => {
                this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },
    downloadCustomerFile: async function(fileId, filename) {
      try {
        this.$store.commit('SHOW_LOADER', true);
        const customerId = this.$route.params.id;
        const response = await CustomerAPIService.downloadCustomerFile(customerId, fileId);
        
        // Create blob and download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
      } catch (error) {
        this.notify("Error downloading file", "Error", "error");
      } finally {
        this.$store.commit('SHOW_LOADER', false);
      }
    },
    updateCustomer(e) {
      this.$store.commit('SHOW_LOADER',true);
      e.preventDefault();
      CustomerAPIService.update(
        this.$route.params.id,
        {
          company_name: this.company_name,
          phone_number: this.phone_number,
          brand_price_tier: this.brand_price_tier,
          brand_promo_code: this.brand_promo_code,
          minimum_order: this.minimum_order,
          maximum_order: this.maximum_order,
          days_invoices_due: this.days_invoices_due,
          tax_id: this.tax_id,
          tax_rate: this.tax_rate,
          rep_name: this.rep_name,
          login_enabled: this.login_enabled,
          send_order_emails: this.send_order_emails,
          require_payment_info: this.require_payment_info,
          allow_card_payment: this.allow_card_payment,
          add_days_to_due_date_on_ship: this.add_days_to_due_date_on_ship,
        })
        .then((response) => {
          this.$store.commit('SHOW_LOADER',false);
          if (response.data.hasOwnProperty("success")) {
            swal.fire("Success!", response.data.success, "success");
            Object.assign(this.$data, this.$options.data());
          } else if (response.data.hasOwnProperty("error")) {
            this.$store.commit('SHOW_LOADER',false);
            this.notify("Error!", response.data.error , "error");
          }
        })
        .catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
          this.notify("Error Exception!", "Error", "error");
        });
    },
    validateCustomerNoteBeforeSubmit() {
      this.spinner = true;
      this.$validator.validate("note.*").then((result) => {
        if (result) {
          this.saveCustomerNote();
        } else {
          this.spinner = false;
          this.buttonDisable = false;
          return;
        }
      });
    },
    saveCustomerNote() {
      if (!this.note || this.note.trim() === "") {
      this.noteSubmitted = true;
      this.note = "";
      return;
      }
      this.$store.commit('SHOW_LOADER',true);
      CustomerAPIService.createNote(
        this.$route.params.id,
        { note: this.note })
        .then((response) => {
          this.$store.commit('SHOW_LOADER',false);
          if (response.data.hasOwnProperty("success")) {
            this.note = "";
            this.buttonDisable = false;
            this.spinner = false;
            this.notify("Success!", response.data.success, "success");
            this.note = "";
            // get fresh notes list after saving a new one.
            this.getCustomerDetail();
          } else if (response.data.hasOwnProperty("error")) {
            this.buttonDisable = false;
            this.spinner = false;
            this.notify('Error!', 'Something went wrong','error');
          }
        })
        .catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
          this.spinner = false;
          this.buttonDisable = false;
          this.notify("Error Exception!", "Error", "error");
        });
      $("#notes_modal").modal("hide");
    },
    deleteNote(noteId) {
      var self = this;
      var customerId = this.$route.params.id;

      swal
        .fire({
          title: this.$t('want_to_delete_this_note'),
          text: this.$t('action_cannot_be_reverted'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then((result) => {
          if (result.value) {
              this.$store.commit('SHOW_LOADER',true)
            CustomerAPIService.deleteNote(customerId, noteId)
              .then((response) => {
                this.$store.commit('SHOW_LOADER',false)
                this.notify('Deleted!', response.data.success, 'success');
                this.getCustomerDetail();
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify('Error Exception!', 'Error', 'error');
              });
          }
        });
    },
    deleteShippingAddress(addressId, addressIndex) {
      var self = this;
      var customerId = this.$route.params.id;
      swal
        .fire({
          title: this.$t('want_to_delete_this_shipping_address'),
          text: this.$t('action_cannot_be_reverted'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then((result) => {
          if (result.value) {
            this.$store.commit('SHOW_LOADER', true);
            CustomerAPIService.deleteShippingAddress(
              customerId,
              addressId
            )
              .then((response) => {
                this.$store.commit('SHOW_LOADER', false);
                this.notify("Deleted!", response.data.success, "success");
                self.shippingAddresses.splice(addressIndex, 1);
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },
    deleteBillingAddress(addressId, addressIndex) {
      var self = this;
      var customerId = this.$route.params.id;
      swal
        .fire({
          title: this.$t('want_to_delete_this_billing_address'),
          text: this.$t('action_cannot_be_reverted'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then((result) => {
          if (result.value) {
            this.$store.commit('SHOW_LOADER', true);
            CustomerAPIService.deleteBillingAddress(
              customerId,
              addressId
            )
              .then((response) => {
                this.$store.commit('SHOW_LOADER', false);
                this.notify("Deleted!", response.data.success, "success");
                this.componentKey += 1
                self.billingAddresses.splice(addressIndex, 1);
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },
    addressOneLine: function (address) {
      // state null handler
      var staTe =  ", " + address.state;
      var stateHandler = ( address.state == null ) ? "" : staTe;
      //phone null handler
      var phoNe =  ", " + address.phone;
      var phoneHandler = ( address.phone  == null ) ? "" : phoNe;
      if (address.address_2) {
        var addressOneLine =
          address.name +
          ", " +
          address.address +
          ", " +
          address.address_2 +
          ", " +
          address.city +
          ", " +
          address.zip_code +
          ", " +
          address.country +
          ", " +
          address.email
          +
          phoneHandler
          +
          stateHandler;
      } else {
        var addressOneLine =
          address.name +
          ", " +
          address.address +
          ", " +
          address.city +
          ", " +
          address.state +
          ", " +
          address.zip_code +
          ", " +
          address.country +
          ", " +
          address.email
          +
          phoneHandler
          +
          stateHandler;
      }
      return addressOneLine;
    },
    addressSaveEvent(eventMessage) {
      if (eventMessage == "shipping-address-saved") {
        this.getCustomerDetail();
      } else if (eventMessage == "billing-address-saved") {
        this.getCustomerDetail();
      }
    },
    contactSaveEvent(eventMessage = null) {
      this.$store.commit('SHOW_LOADER',true);
      // Refresh contact persons list.
      ContactPersonAPIService.getAll(this.$route.params.id)
        .then((response) => {
          this.$store.commit('SHOW_LOADER',false);
          this.contactPersons = response.data.contactPersons;
          this.loginEnabled = this.contactPersons[0].login_enabled;
          // this.users = response.data.user;
          this.customerLastLogin = response.data.contactPersons[0].last_login;
          this.getCustomerDetail();
        })
        .catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
          this.notify("Error Exception!", "Error", "error");
        });
    },
    contactPasswordEvent: function (eventMessage) {
      // Refresh contact persons list.
    },

    deleteContactPerson: function (contactPersonId, contactPersonIndex) {
      var self = this;
      var customerId = this.$route.params.id;
      swal
        .fire({
          title: this.$t('want_to_delete_this_customer_contact'),
          text: this.$t('action_cannot_be_reverted'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then(function (result) {
          if (result.value) {
            ContactPersonAPIService.deleteContactPerson(
              customerId,
              contactPersonId
            ).then((response) => {
                if (response.data.hasOwnProperty("success")) {
                  swal.fire("Success!", response.data.success, "success");
                } else if (response.data.hasOwnProperty("error")) {
                  swal.fire("Error!", "Something went wrong", "error");
                }
                self.contactPersons.splice(contactPersonIndex, 1);
                this.getCustomerDetail();
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },
    editContactPerson: function (contactPerson) {
      if ($("#contact-person-modal")) {
        eventBus.emit("showCustomerSharedData", contactPerson);
        $("#contact-person-modal").modal("show");
      }
    },
    switchContactPersonToPrimary: function (contactPerson) {
      //
        const vm = this;
        ContactPersonAPIService.switchContactPersonToPrimary(
          {'contact_person_id': contactPerson.id}
        ).then((response) => {
          if(response.data.hasOwnProperty('success')) {
            vm.notify('Success!',response.data.success,'success');
            this.contactSaveEvent();
          }
        }).catch((error) => {
          const response = error.response;
          vm.notify('Oops!',response.data.error,'error');
        });

    },
    resetPasswordContactPerson: function (contactPerson) {
      if ($("#reset-password-contact-modal")) {
        this.$root.eventBus.emit("resetPasswordContactSharedData", contactPerson);
        $("#reset-password-contact-modal").modal("show");
      }
    },
    triggerAddContactPerson: function () {
      eventBus.emit("addNewConstactPersonEvent");
    },
    triggerAddShippingEvent: function () {
      this.showBillingAddressModal = false
      this.showShippingAddressModal = true;
      this.$root.eventBus.emit("ShippingAddress::Add");
    },
    triggerEditShippingEvent: function (address) {
      this.showBillingAddressModal = false
      this.showShippingAddressModal = false;
      this.showShippingAddressModal = true;
      this.$root.eventBus.emit("ShippingAddress::Edit", address);
      // $("#shipping_address").modal("show");
    },
    triggerAddBillingEvent: function () {
      this.showShippingAddressModal = false;
      this.showBillingAddressModal = true;
      this.$root.eventBus.emit("BillingAddress::Add");
    },
    triggerEditBillingEvent: function (address) {
      this.showShippingAddressModal = false;
      this.showBillingAddressModal = false;
      this.showBillingAddressModal = true;
      this.$root.eventBus.emit("BillingAddress::Edit", address);
      // $("#billing_address").modal("show");
    },
    validateCustomerStoreCreditBeforeSubmit() {
      this.spinner = true;
      this.buttonDisable = true;
      this.saveCreditNote();
    },
    patchRestoreBrandCustomer() {
      let data = {
        customerId: this.$route.params.id,
      };
      swal
        .fire({
          title: this.$t('warning'),
          text: this.$t('want_to_restore_this_deleted_customer'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('yes'),
        })
        .then((result) => {
          if (result.value) {
            CustomerAPIService.patchRestoreBrandCustomer(
              this.customerId,
              data)
              .then((response) => {
                if (response.data.hasOwnProperty("success")) {
                   this.notify(
                    "Customer Restore!",
                    response.data.success,
                    "success"
                  );
                  this.$router.push({ name: "brand-customers-list" });
                } else if (response.data.hasOwnProperty("error")) {
                   this.notify("Error!", response.data.error, "error");
                }
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                 this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },
    saveCreditNote() {
      this.$store.commit('SHOW_LOADER',true);
      CustomerAPIService.createStoreCredit(
        this.$route.params.id,
        { amount: this.credit_amount, note: this.credit_note })
        .then((response) => {
          this.$store.commit('SHOW_LOADER',false);
          if (response.data.hasOwnProperty("success")) {
            $("#store_credit_modal").modal("toggle");
            this.buttonDisable = false;
            this.spinner = false;
             this.notify("Success!", response.data.success, "success");
          } else if (response.data.hasOwnProperty("error")) {
            $("#store_credit_modal").modal("toggle");
            this.buttonDisable = false;
            this.spinner = false;
            var errorsHtml = "";
            errorsHtml +=
              '<span class="kt-font-danger">' +
              response.data.error +
              "</span><br>";
              this.notify("<strong>Add New <u>Customer Store Credit</u></strong>", errorsHtml, "error");

            //  this.notify({
            //   title: "<strong>Add New <u>Customer Store Credit</u></strong>",
            //   icon: "error",
            //   html: errorsHtml,
            //   showCloseButton: true,
            // });
          }
        })
        .catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
           this.notify("Error Exception!", "Error", "error");
          this.buttonDisable = false;
          this.spinner = false;
        });
    },
    enableCustomer() {
      this.$store.commit('SHOW_LOADER',true);
      CustomerAPIService.enableCustomer(
        this.$route.params.id)
        .then((response) => {
          this.$store.commit('SHOW_LOADER',false);
          if (response.data.hasOwnProperty("success")) {
            this.status = "active";
            this.notify("Success!", response.data.success, "success");
            this.selectTab('kt_tab_pane_1_9');
          } else if (response.data.hasOwnProperty("error")) {
            this.notify("Error!", "Something went wrong", "error");
          }
        })
        .catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
          this.notify("Error Exception!", "Error", "error");
        });
    },
    disableCustomer() {
      this.$store.commit('SHOW_LOADER',true);
      CustomerAPIService.disableCustomer(
        this.$route.params.id)
        .then((response) => {
          this.$store.commit('SHOW_LOADER',false);
          if (response.data.hasOwnProperty("success")) {
            this.status = "inactive";
            this.notify("Success!", response.data.success, "success");
          } else if (response.data.hasOwnProperty("error")) {
            this.notify("Error!", "Something went wrong", "error");
          }
        })
        .catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
          this.notify("Error Exception!", "Error", "error");
        });
    },
    saveAuthorizeCard: function () {
      if (!this.validatedCard()) {
        return false;
      }
      let cardExpiry = this.cardExpiry.split("/");
      let data = {
        customer_id: this.$route.params.id,
        card_number: this.cardNumber,
        cvv2: this.cardCvc,
        exp_month: cardExpiry[0],
        exp_year: cardExpiry[1],
      };
      // Create info.
      this.$store.commit('SHOW_LOADER',true);
      CustomerAPIService.createAuthorizePaymentCardInfo(data)
        .then((response) => {
          if (response.data.hasOwnProperty("success")) {
            this.resetCard();
            this.customerAuthorizeNetCards();
            swal.fire("Success!", response.data.success, "success");
            this.$store.commit('SHOW_LOADER',false);
          } else if (response.data.hasOwnProperty("error")) {
            this.notify("Error!", response.data.error , "error");
            this.$store.commit('SHOW_LOADER',false);
          }
        })
        .catch((error) => {
          this.notify("Error Exception!", response.data.error, "error");
        });
    },
    deleteAuthorizeCard: function (
      customerProfileId,
      customerPaymentProfileId
    ) {
      let data = {
        customer_id: this.$route.params.id,
        customer_profile_id: customerProfileId,
        customer_payment_profile_id: customerPaymentProfileId,
      };
      let vm = this;
      swal
        .fire({
          title: this.$t('want_to_delete_this_payment_card'),
          text: this.$t('action_cannot_be_reverted'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then(function (result) {
          if (result.value) {
            CustomerAPIService.deleteAuthorizePaymentCardInfo(
              data)
              .then((response) => {
                if (response.data.hasOwnProperty("success")) {
                  vm.customerAuthorizeNetCards();
                  swal.fire("Success!", response.data.success, "success");
                } else if (response.data.hasOwnProperty("error")) {
                  this.notify("Error!", response.data.error , "error");
                }
              })
              .catch((error) => {
                this.notify("Error Exception!", error, "error");
              });
          }
        });
    },
    validatedCard: function () {
      // init
      this.cardErrors = {};
      let validated = true;

      // validate card number
      // if (!this.$cardFormat.validateCardNumber(this.cardNumber)) {
      //   this.cardErrors.cardNumber = "Invalid Credit Card Number.";
      //   validated = false;
      // }

      // validate card expiry
      // if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
      //   this.cardErrors.cardExpiry = "Invalid Expiration Date.";
      //   validated = false;
      // }

      // validate card CVC
      // if (!this.$cardFormat.validateCardCVC(this.cardCvc)) {
      //   this.cardErrors.cardCvc = "Invalid CVC.";
      //   validated = false;
      // }
      return validated;
    },
    resetCard: function () {
      this.cardErrors = {};
      this.cardNumber = null;
      this.cardExpiry = null;
      this.cardCvc = null;
      //this.cardPostal = null;
      this.$refs.cardNumInput.focus();
    },
    customerAuthorizeNetCards: function () {
      CustomerAPIService.customerAuthorizeNetCards(
        this.$route.params.id)
        .then((response) => {
          if (response.data.hasOwnProperty("customerAuthorizeNetPaymentInfo")) {
            this.customerAuthorizeNetPaymentInfo =
              response.data.customerAuthorizeNetPaymentInfo; // will be replaced with cards array.
          }
        })
        .catch((error) => {
          this.notify("Error Exception!",error, "error");
        });
    },
    setAuthorizeNetCardAsDefault: function (
      customerProfileId,
      customerPaymentProfileId
    ) {
      let data = {
        customer_id: this.$route.params.id,
        customer_profile_id: customerProfileId,
        customer_payment_profile_id: customerPaymentProfileId,
      };
      CustomerAPIService.setAuthorizeNetCardAsDefault(data)
        .then((response) => {
          if (response.data.hasOwnProperty("success")) {
            this.customerAuthorizeNetCards();
          }
        })
        .catch((error) => {
          this.notify("Error Exception!", error, "error");
        });
    },
    handleRowFunction($event, row) {
      if ($(event.target).hasClass("delete-notification-email")) {
        this.deleteNotificationEmail(row);
      }
    },
    deleteNotificationEmail(notificationEmail) {
      swal
        .fire({
          title: this.$t('are_you_sure'),
          text: this.$t('want_to_delete_this_notification_email'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then((result) => {
          if (result.value) {
            AccountSettingAPIService.deleteNotificationEmail(notificationEmail.id,notificationEmail.customer_id)
              .then((response) => {
                if (response.data.hasOwnProperty("success")) {
                  this.removeNotificationEmailList(notificationEmail.id);
                  this.getCustomerDetail();
                  this.notify("Deleted!", response.data.success, "success");
                } else if (response.data.hasOwnProperty("error")) {
                  this.notify("Error!", response.data.error, "error");
                }
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },
    removeNotificationEmailList(emailId) {
      this.notificationEmails = this.notificationEmails.filter((row) => {
        if (row.id === emailId) {
          return false;
        }
        return true;
      });
    },
    resendWelcomeEmail() {
      this.$store.commit('SHOW_LOADER',true);
      if(this.loginEnabled){
        swal
        .fire({
          title: this.$t('warning'),
          text: this.$t('customer_password_Reset_email_temporary_password'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('yes'),
        })
        .then((result) => {
          if (result.value) {
            CustomerAPIService.customerResendWelcomeEmail(
              this.$route.params.id)
              .then((response) => {
                this.$store.commit('SHOW_LOADER',false);
                if (response.data.hasOwnProperty("success")) {
                  this.notify("Email Sent!", response.data.success, "success");
                } else if (response.data.hasOwnProperty("error")) {
                  this.notify("Error!", response.data.error, "error");
                }
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify("Error Exception!", "Error", "error");
              });
            }
          else{
            this.$store.commit('SHOW_LOADER',false);
          }
          
        });
      } else {
        swal.fire({
          title: this.$t('customer_login_is_disabled'),
          text: this.$t('enable_login_for_this_customer_first'),
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t('Ok'),
        })
        this.$store.commit('SHOW_LOADER', false);
      }
    },
    deleteCustomer(id) {
      swal
        .fire({
          title: this.$t('are_you_sure'),
          text: this.$t('want_to_delete_this_customer'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then((result) => {
          if (result.value) {
            CustomerAPIService.delete(this.$route.params.id)
              .then((response) => {
                if (response.data.hasOwnProperty("success")) {
                  this.$router.push("/dashboard/customers");
                  this.notify("Deleted!", response.data.success, "success");
                } else if (response.data.hasOwnProperty("error")) {
                  this.notify("Error!", response.data.error, "error");
                }
              })
              .catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },

    // Payflow Pro related methods.
    savePayflowCard: function(){
      this.spinner = true;
      if (!this.validatedCard()){
        this.spinner = false;
        return false;
      }
      let cardExpiry = this.cardExpiry.split("/");
      let data = {
        customer_id: this.$route.params.id,
        card_number: this.cardNumber,
        cvv2: this.cardCvc,
        exp_month: cardExpiry[0],
        exp_year: cardExpiry[1],
      };
      // Create info.
      CustomerAPIService.createPayflowPaymentCardInfo(data)
        .then((response) => {
        this.spinner = false;
          if (response.data.hasOwnProperty("success")) {
            swal.fire("Success!", response.data.success, "success");
            this.resetCard();
            this.getCustomerDetail();
          } else if (response.data.hasOwnProperty("error")) {
             this.notify("Error!", response.data.error , "error");
          }
        })
        .catch((error) => {
          this.notify("Error Exception!", "Error", "error");
        });
    },

    deletePayflowCard: function (
      customerProfileId,
      customerPaymentProfileId
    ) {
      let data = {
        customer_id: this.$route.params.id,
        customer_profile_id: customerProfileId,
        customer_payment_profile_id: customerPaymentProfileId,
      };
      let vm = this;
      swal
        .fire({
          title: this.$t('want_to_delete_this_payment_card'),
          text: this.$t('action_cannot_be_reverted'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('yes_delete_it'),
        })
        .then(function (result) {
          if (result.value) {

            CustomerAPIService.deletePayflowPaymentCardInfo(data)
              .then((response) => {
                if (response.data.hasOwnProperty("success")) {
                  vm.customerPayflowPaymentInfo = '';
                  vm.getCustomerDetail();
                  swal.fire("Success!", response.data.success, "success");
                } else if (response.data.hasOwnProperty("error")) {
                  this.notify("Error!", "Something went wrong", "error");
                }
              })
              .catch((error) => {
                this.notify("Error Exception!", "Error", "error");
              });
          }
        });
    },
    selectTab(tabId) {
      const tab = document.querySelector(`a[data-toggle="tab"][href="#${tabId}"]`);
      if (tab) {
        tab.click();
      }
    },
    goToOrder(){
      this.$store.commit('SET_CUSTOMER_ID',this.$route.params.id)
      this.$router.push('/dashboard/orders/create');
     },
    

  },
};
</script>
<style scoped>
.label.label-inline.label-lg{
  margin-top:3px;
}
.dropzone-custom-content {
  position: absolute;
  margin-top: 25px;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.dropzone-custom-title {
  margin-top: 0;
  color: #5d78ff;
}
.subtitle {
  color: #6c7293;
}
.vue-dropzone {
  border: dashed 2px #5d78ff;
}
.card.card-custom {
  border-radius: 4px !important;
}
.nav.nav-bold .nav-item .nav-link .nav-text {
  font-weight: bold;
}

@media (max-width: 768px) {
  .cartbutton {
    margin-right: 12px !important;
  }
  .customer-detail-tabs-toolbar {
    width: 100%;
    min-width: 0;
  }
  .customer-detail-tabs {
    flex-wrap: nowrap !important;
    width: 100%;
    max-width: 100%;
  }
  .customer-detail-tabs > .nav-item {
    flex: 1 1 0 !important;
    width: 33.3333%;
    min-width: 0;
  }
  .customer-detail-tabs > .nav-item > .nav-link {
    display: flex;
    justify-content: center;
    width: 100%;
    padding-right: 2px !important;
    padding-left: 2px !important;
    text-align: center;
    white-space: nowrap;
  }
  .customer-detail-tabs .dropdown-menu {
    width: max-content !important;
    min-width: max-content !important;
    max-width: calc(100vw - 20px);
  }
  .customer-detail-info .form-group.row > [class*='col-'] {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-width: 0;
    margin-bottom: 0 !important;
    padding-top: 8px !important;
  }
  .customer-detail-info .form-group.row > [class*='col-'] > br {
    display: none;
  }
  .customer-detail-info .form-group.row > [class*='col-'] > label {
    flex: 0 0 auto;
    margin-bottom: 0 !important;
    white-space: nowrap;
  }
  .customer-detail-info .form-group.row > [class*='col-'] > span {
    min-width: 0;
    text-align: right;
    white-space: nowrap;
  }
  .customer-detail-info .form-group.row > [class*='col-'] > span:first-of-type {
    margin-left: auto;
  }
  #kt_tab_pane_5_9 :deep(.files) {
    box-sizing: border-box;
    overflow: hidden;
  }
  #kt_tab_pane_5_9 :deep(.file-item) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    overflow: hidden;
  }
  #kt_tab_pane_5_9 :deep(.file-item .img-preview),
  #kt_tab_pane_5_9 :deep(.file-item embed) {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 0;
    box-sizing: border-box;
    object-fit: contain;
  }
  #kt_tab_pane_5_9 :deep(.file-item > span:not(.delete-file)) {
    display: block;
    width: 100%;
    text-align: left;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  #kt_tab_pane_5_9 :deep(.file-item .delete-file) {
    align-self: flex-end;
    flex: 0 0 auto;
  }
  .html-mobile-card-footer {
  justify-content: flex-start !important;
  gap: 10px !important;
  flex-wrap: nowrap !important;
  }
  .html-mobile-card-action {
  width: 32px !important;
  height: 32px !important;
  }
  :deep(.html-mobile-card-portal[data-table-id='customer-contacts-table'] .html-mobile-card-footer),
  :deep(.html-mobile-card-portal[data-table-id='customer-documents-table'] .html-mobile-card-footer) {
    flex-wrap: nowrap !important;
    gap: 10px !important;
  }
  :deep(.html-mobile-card-portal[data-table-id='customer-contacts-table'] .html-mobile-card-footer > .dropdown-item),
  :deep(.html-mobile-card-portal[data-table-id='customer-documents-table'] .html-mobile-card-footer > .dropdown-item) {
    display: inline-flex !important;
    flex: 0 0 32px;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0 !important;
  }
  :deep(.html-mobile-card-portal[data-table-id='customer-contacts-table'] .html-mobile-card-footer > .dropdown-item i),
  :deep(.html-mobile-card-portal[data-table-id='customer-documents-table'] .html-mobile-card-footer > .dropdown-item i) {
    margin: 0 !important;
  }
}
h3 {
  font-weight: 700;
}
.tabContentHeader {
  background-color: #eef0f8 !important;
  /*opacity: 0.9;*/
}
.form-group label {
  font-weight: 600 !important;
}
.card.card-custom > .card-body {
  padding: 1rem 2.25rem !important;
}
.filesHeader {
  background-color: #dbd9d9 !important;
}
.noOrdersContent {
  color: #e76450 !important;
}
.alert.alert-secondary{
  border-radius: 0px !important;
  background-color: #f7f7f7 !important;
}
th{
    text-align: left;
  }
td{
    text-align: left;
  }
.danger {
  color:#fd397a;
}
.borderr{
  border:1px solid #fd397a !important;
}
.label.label-paid {
  background-color:#2ECC71;
  color:#ffffff;
}
.label.label-warning {
  background-color:#FFC300;
  color:#FFFFFF;
}
.label.label-inline {
  padding: 10px 5px !important;
  border-radius: 4px !important;
}
.invalid-feedbacks{
	width: 100%;
    margin-top: .25rem;
    font-size: .9rem;
    color: #f64e60
}

.card.card-custom > .card-body{
    padding: 0.25rem 0.50rem !important;
}
.col-xl-3 {
    position: relative;
    max-width: 20%;
    padding-right: 12.5px;
    padding-left: 12.5px;
}
.position-btn{
    position: relative;
    bottom: 10px;
}
.typo{
    font-size: 12px;
    font-weight: 300;
    padding-left: 6px;
    position: relative;
    bottom: 2px;
    word-spacing: 2px;
    letter-spacing: .4px;
}
/* Responsive columns */
@media screen and (max-width: 1100px) {
  .col-xl-3 {
    max-width: 100%;
    display: block;
    /*margin-bottom: 20px;*/
  }
}
.fa-credit-card{
  color: danger !important;
}
.creditIconColor{
  color: #F64E60 !important;
}
.fileIconColor {
  color: #1BC5BD !important;
}
.calendarIconColor {
  color: #3699FF !important;
}
.moneyIconColor {
  color: #1BC5BD !important;
}
.shoppingIconColor{
  color: #FFA800 !important;
}
.minHeight{
  min-height: 50px !important;
}
.flex-column-fluid{
  flex:0 !important;
}
</style>
